// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
  baseUrl:
    | "http://localhost"
    | "https://dev.payments.pepperstone.com"
    | "https://stg.payments.pepperstone.com"
    | (string & {});
};

export type Result = {
  code: number;
  message: string;
};

export type ServiceVersion = {
  /**
   * The deployed build version. This is the release tag (an RC tag such as `v0.23.0-PNX-1234.abc1234` or a release tag such as `v0.23.0`) when the image was built for a tagged/branch release; otherwise it falls back to the Git commit SHA. Consumers MUST NOT assume this is always a 40-char commit SHA.
   */
  commitHash: string;
  time: string;
};

export type Error = {
  code: number;
  message: string;
  key: EnumErrorKey;
};

export type Tokens = {
  idToken: string;
  accessToken: string;
};

export type TokenVerification = {
  valid: boolean;
};

export type CashierUserData = {
  /**
   * Customer full name
   */
  name: string;
  /**
   * Email address
   */
  email: string;
  /**
   * Customer SCA ID
   */
  sca_id: number;
  /**
   * License PNX ID
   */
  license_id: string;
  /**
   * License Name
   */
  license_name: string;
  /**
   * Country ISO Code
   */
  country_code: string;
  /**
   * Live trading accounts
   */
  accounts: Array<CashierTradingAccount>;
  legal_entities: LegalEntities;
};

/**
 * Create internal transfer response
 */
export type CreateInternalTransferResponse = {
  [key: string]: unknown;
};

export type AmountCurrencyResponse = {
  /**
   * The amount as an integer without decimal separator
   */
  amount: string;
  /**
   * The number of decimal places
   */
  decimals: number;
  /**
   * The code of the currency
   */
  code: string;
};

export type InternalCodes = {
  /**
   * The corresponding uuid of the received three letter country code
   */
  country_code: string;
  currency: CurrencyPrimitive;
  /**
   * The corresponding uuid of the received license name
   */
  license_id: string;
};

export type CashierTransactionView = {
  /**
   * Reference ID of the transaction
   */
  reference_id: string;
  /**
   * Source TradingAccount ID, required for withdrawal and transfer
   */
  from_trading_account?: string;
  /**
   * Target TradingAccount ID, required for deposit, transfer and cash adjustment
   */
  to_trading_account?: string;
  /**
   * Source SavedPaymentAccount, required for deposit
   */
  saved_payment_account?: CashierTransactionHistorySavedPaymentAccount;
  /**
   * Amount of the transaction
   */
  money: AmountCurrencyResponse;
  /**
   * Status of the transaction
   */
  status: EnumCashierTxStatus;
  /**
   * The type of the Transaction history record.
   */
  type: EnumPaymentType;
  /**
   * The fee of transaction in processing currency.
   */
  fee_money?: AmountCurrencyResponse;
  /**
   * Date and time of the transaction
   */
  created_at: Date;
};

/**
 * The type of the payment record.
 */
export const EnumPaymentType = {
  /**
   * EnumPaymentTypeDeposit
   */
  EnumPaymentTypeDeposit: "deposit",
  /**
   * EnumPaymentTypeWithdrawal
   */
  EnumPaymentTypeWithdrawal: "withdrawal",
  /**
   * EnumPaymentTypeTransfer
   */
  EnumPaymentTypeTransfer: "transfer",
  /**
   * EnumPaymentTypeCashAdjustment
   */
  EnumPaymentTypeCashAdjustment: "cashAdjustment",
} as const;

/**
 * The type of the payment record.
 */
export type EnumPaymentType =
  (typeof EnumPaymentType)[keyof typeof EnumPaymentType];

export type CashierTransactionViewDetails = CashierTransactionView & {
  /**
   * The ordered list of transaction timeline steps, including the expected future steps.
   */
  timeline: Array<CashierTransactionTimelineStep>;
  /**
   * The amount of transaction in processing currency.
   */
  money_in_processing_currency: AmountCurrencyResponse;
  /**
   * The net amount (after fee deduction) in the trading currency, used to display the "You receive" amount. Equals `money` minus the fee. When the fee currency differs from the trading currency, the fee is converted to the trading currency using the recorded exchange rate.
   */
  net_money_in_trading_currency?: AmountCurrencyResponse;
  /**
   * The exchange rate of transaction in trading currency. `{exchange_rate_unit} {processing_currency} = {exchange_rate} {currency}`
   */
  exchange_rate?: number;
  /**
   * Unit of the exchange rate in processing currency, possible values 1..1000 (e.g. 1000 HUF = 2.5EUR) `{exchange_rate_unit} {processing_currency} = {exchange_rate} {currency}`
   */
  exchange_rate_unit?: number;
  /**
   * The reason of cash adjustment. e.g. "Promotion Bonus"
   */
  cash_adjustment_reason?: string;
  /**
   * The withdrawal request ID. Only present for withdrawal transactions.
   */
  withdrawal_request_id?: string;
};

/**
 * The type of the arrangement.
 */
export const EnumArrangementType = {
  /**
   * EnumArrangementTypeDeposit
   */
  EnumArrangementTypeDeposit: "deposit" /**
   * EnumArrangementTypeWithdrawal
   */,
  EnumArrangementTypeWithdrawal: "withdrawal",
} as const;

/**
 * The type of the arrangement.
 */
export type EnumArrangementType =
  (typeof EnumArrangementType)[keyof typeof EnumArrangementType];

/**
 * Transaction status
 */
export type TransactionSummary = {
  /**
   * Balance of the trading account
   */
  balance: AmountCurrencyResponse;
  /**
   * Amount of the transaction
   */
  money: AmountCurrencyResponse;
  status: EnumCashierTxStatus;
  /**
   * External ID of the trading account
   */
  external_trading_account_id: string;
};

export type ExchangeRate = {
  /**
   * The source currency from which we are exchanging along with the its amount
   */
  from_money: AmountCurrencyResponse;
  /**
   * The target currency to which we are exchanging into along with the its amount
   */
  to_money: AmountCurrencyResponse;
  /**
   * The rate at which the currency was converted from the fromAmount to the toAmount
   */
  rate: number;
  /**
   * The transaction fee in the target currency
   */
  fee: AmountCurrencyResponse;
};

export type RawExchangeRate = {
  /**
   * The source currency from which we are exchanging along with the its money
   */
  from_money: AmountCurrencyResponse;
  /**
   * The target currency to which we are exchanging into along with the its money
   */
  to_money: AmountCurrencyResponse;
  /**
   * The rate at which the currency was converted from the fromAmount to the toAmount
   */
  rate: number;
};

/**
 * Get transfer exchange rate response
 */
export type TransferExchangeRateResponse = {
  /**
   * The target money to which we are exchanging into
   */
  target_money: AmountCurrencyResponse;
  /**
   * The rate at which the currency was converted from the fromAmount to the toAmount
   */
  rate: string;
  /**
   * The timestamp (in RFC3339 format) at which the exchange rate expires and a new rate should be requested
   */
  expiration_timestamp: Date;
};

export type TradingAccountsByMarginResponse = {
  /**
   * Trading accounts sorted by free margin in descending order (normalized to AUD)
   */
  accounts: Array<CashierTradingAccountMargin>;
};

/**
 * Basic information about a currency.
 */
export type CurrencyPrimitive = {
  /**
   * Currency code
   */
  code: string;
  /**
   * Currency name
   */
  name: string;
  /**
   * Number of decimal places for minor unit
   */
  decimals: number;
  /**
   * Symbol of the currency
   */
  symbol: string;
};

/**
 * Alert text for a page
 */
export type PageAlert = {
  /**
   * The value of page alert text.
   */
  alert_text: string | null;
};

/**
 * The request to start a deposit transaction. This can be done as a customer or as a payops merchant on behalf of a customer.
 *
 */
export type StartDepositTransaction = {
  /**
   * The unique identifier of the payment method.
   */
  payment_method_id: string;
  /**
   * The amount in the trading currency.
   */
  trading_amount_with_currency: AmountCurrencyRequest;
  /**
   * The unique identifier of the account the customer is paying from.
   */
  trading_account_id: string;
  /**
   * Additional data that can be passed in the request.
   */
  additional_data?: {
    [key: string]: unknown;
  };
  /**
   * The unique identifier of the saved payment account to use for this transaction. If not provided, a new payment account will be created either empty or using the form fields.
   */
  saved_payment_account_id?: string;
  form_fields?: SavedPaymentAccountFields;
  /**
   * Whether to validate the SPA fields from the PSP response against the required field list on our side in the payment method config. If true, the transaction and the SPA will only be created if all required fields are present in the PSP response. If false, the transaction and the SPA will be created regardless of the fields present in the PSP response.
   */
  validate_spa_fields: boolean;
};

export type InitSessionTokenResponse = {
  /**
   * The session token to be used for WEB SDK
   */
  session_token?: string;
  /**
   * The merchant ID to be used for WEB SDK
   */
  merchant_id?: string;
  /**
   * The merchant site ID to be used for WEB SDK
   */
  merchant_site_id?: string;
  /**
   * The environment value to be used for WEB SDK
   */
  env?: string;
};

/**
 * The type of the payment flow action.
 */
export const EnumActionType = {
  /**
   * EnumActionTypeIframe
   */
  EnumActionTypeIframe: "iframe",
  /**
   * EnumActionTypeIframeWithManualConfirm
   */
  EnumActionTypeIframeWithManualConfirm: "iframe_with_manual_confirm",
  /**
   * EnumActionTypeCard
   */
  EnumActionTypeCard: "card",
  /**
   * EnumActionTypeRedirect
   */
  EnumActionTypeRedirect: "redirect",
  /**
   * EnumActionTypeBankTransfer
   */
  EnumActionTypeBankTransfer: "bank_transfer",
  /**
   * EnumActionTypeApm
   */
  EnumActionTypeApm: "apm",
} as const;

/**
 * The type of the payment flow action.
 */
export type EnumActionType =
  (typeof EnumActionType)[keyof typeof EnumActionType];

/**
 * Response after updating a deposit transaction
 */
export type UpdateDepositTransactionResponse = {
  /**
   * The UPO (User Payment Option) ID returned by the PSP after registering a new card via HandleUPO. Present only in the new card flow.
   */
  user_payment_option_id?: string;
  transaction_status?: EnumTransactionStatus;
};

/**
 * The name of a trading platform.
 */
export const EnumTradingPlatform = {
  /**
   * EnumTradingPlatformMT4
   */
  EnumTradingPlatformMt4: "MT4",
  /**
   * EnumTradingPlatformMT5
   */
  EnumTradingPlatformMt5: "MT5",
  /**
   * EnumTradingPlatformCTrader
   */
  EnumTradingPlatformCTrader: "cTrader",
  /**
   * EnumTradingPlatformTradingView
   */
  EnumTradingPlatformTradingView: "TradingView",
  /**
   * EnumTradingPlatformPepperstone
   */
  EnumTradingPlatformPepperstone: "Pepperstone",
} as const;

/**
 * The name of a trading platform.
 */
export type EnumTradingPlatform =
  (typeof EnumTradingPlatform)[keyof typeof EnumTradingPlatform];

/**
 * Returns the payment method arrangement. If there is a last used payment method, it will be returned as well. Also, the last used payment method will always be the first element in the arrangement array.
 */
export type GetPaymentMethodsResponse = {
  last_used_payment_method?: LastUsedPaymentMethod;
  arrangement: Array<CashierPaymentMethodArrangementItem>;
};

/**
 * Returns withdrawal payment methods.
 */
export type GetWithdrawalPaymentMethodsResponse = {
  payment_methods: Array<CashierPaymentMethod>;
};

export type PaymentMethodGroupWithMembers = {
  /**
   * Payment Method Group ID
   */
  id: string;
  /**
   * Payment Method Group Name
   */
  name: string;
  /**
   * URL to the logo of the payment method group
   */
  logo: string;
  availability_status: EnumPaymentMethodGroupState;
  /**
   * The name of the payment method category.
   */
  category_name: string;
  /**
   * The name of the payment method subcategory.
   */
  subcategory_name?: string;
  /**
   * The processing currencies of the payment method group.
   */
  processing_currencies: Array<string>;
  /**
   * The allowed licenses of the payment method group.
   */
  allowed_licenses: Array<string>;
  /**
   * The allowed transaction types of the payment method group.
   */
  allowed_transaction_types: Array<EnumTransactionType>;
  /**
   * List of payment methods that belong to this group
   */
  payment_methods: Array<PaymentMethodGroupMember>;
};

export type WithdrawalRequestTotalAmount = {
  /**
   * Total amount of the withdrawal transactions
   */
  amount_with_currency: AmountCurrencyRequest;
  /**
   * The unique identifier of the trading account.
   */
  trading_account_id: string;
};

export type TradingAccountRefundBalance = {
  total_money: AmountCurrencyResponse;
  refundable_money: AmountCurrencyResponse;
  profit_money: AmountCurrencyResponse;
  /**
   * A mapping of ledger IDs to their respective amounts.
   */
  ledger_amounts: {
    [key: string]: AmountCurrencyResponse;
  };
  /**
   * A mapping of ledger IDs to a mapping of currency codes to their respective currency conversions.
   */
  currency_conversion_by_asset: {
    [key: string]: {
      [key: string]: CurrencyConversion;
    };
  };
  refund_accounts: Array<SavedPaymentAccountRefundSummary>;
  /**
   * A mapping of payment method IDs to their respective payout account details.
   */
  payout_accounts?: {
    [key: string]: TradingAccountRefundBalancePayoutAccounts;
  };
};

/**
 * Create a new saved payment account
 */
export type CreateSavedPaymentAccountSchema = {
  /**
   * The unique identifier of the payment method.
   */
  payment_method_id: string;
  fields: SavedPaymentAccountFields;
  /**
   * The credit card temporary token.
   */
  cc_temp_token?: string;
  /**
   * The payment service provider token.
   */
  psp_token?: string;
  /**
   * Amount to withdraw from SavedPaymentAccount
   */
  amount_with_currency: AmountCurrencyRequest;
  /**
   * The document ID to associate with the saved payment account upon creation. Used for bank statement pre-uploads where the document exists before the SPA.
   */
  document_id?: string;
};

export type SavedPaymentAccountSummary = {
  /**
   * The unique identifier of the saved payment account.
   */
  id: string;
  /**
   * The unique identifier of the payment method associated with the saved payment account.
   */
  payment_method_id: string;
  /**
   * The URL of the logo associated with the saved payment account.
   */
  logo_url: string;
  /**
   * Payment method name.
   */
  name: string;
  /**
   * The detail identifies the saved payment account to the customer.
   * There are multiple types of saved payment accounts, such as credit cards, bank accounts, etc.
   * The detail is used to provide additional information about the payment method,
   * such as the last four digits of a credit card or email address for APMs like PayPal.
   *
   */
  detail: string;
  /**
   * Additional information about the saved payment account,
   * such as the expiration date for credit cards,
   * or last 4 digits of bank accounts etc..
   *
   */
  secondary_detail?: string;
  /**
   * The minimum amount that can be withdrawn to this saved payment account.
   */
  minimum_amount: AmountCurrencyResponse;
  /**
   * The maximum amount that can be withdrawn to this saved payment account.
   */
  maximum_amount: AmountCurrencyResponse;
  /**
   * Fee information for this profit payment accounts entry.
   */
  fee: FeeSettingsResponse;
  /**
   * The availability status of the payment method for this saved payment account.
   */
  status?: EnumPaymentMethodState;
  /**
   * The reason why this saved payment account is disabled (when status is offline).
   */
  disabled_reason?: EnumDisabledReason;
  /**
   * List of currencies with exchange rates, when it is allowed for customer to choose processing currency.
   */
  processing_currencies: Array<CurrencyWithRate>;
  /**
   * Information message of the payment method, sourced from the payout network settings.
   */
  info_message: string;
  /**
   * Expected processing time of the payment method, sourced from the payout network settings.
   */
  expected_processing_time: string;
};

export type DocumentUpdateStatusRequest = {
  status: EnumDocumentUploadStatus;
};

/**
 * The request body for creating a withdrawal request or just executing transaction calculation
 */
export type WithdrawalRequest = {
  /**
   * List of saved payment account IDs with amounts to withdraw from.
   */
  refund_saved_payment_accounts: Array<SavedPaymentAccountRefundAmounts>;
  profit_saved_payment_account?: SavedPaymentAccountProfitAmount;
};

export type WithdrawalRequestCreated = {
  /**
   * The unique identifier for the withdrawal request.
   */
  withdrawal_request_id: string;
  verification_type: EnumVerificationType;
  /**
   * Timestamp of when the withdrawal request was created
   */
  created_at: Date;
  /**
   * The time limit for the withdrawal request in minutes.
   */
  time_limit_in_minutes: number;
};

export type WithdrawalMfaVerification = {
  /**
   * The access token of the user which includes the grant type and the scope of the MFA (this is done by Auth0).
   */
  access_token: string;
};

export type WithdrawalVerificationResult = {
  /**
   * The unique identifier for the withdrawal request.
   */
  withdrawal_request_id: string;
  /**
   * The unique identifier for the trading account associated with the withdrawal request.
   */
  trading_account_id: string;
  /**
   * The money in the trading currency.
   */
  trading_money: AmountCurrencyResponse;
  confirmation_status: EnumConfirmationStatus;
};

export type WithdrawalRequestStatus = {
  /**
   * The unique identifier for the withdrawal request.
   */
  withdrawal_request_id: string;
  /**
   * The unique identifier for the trading account associated with the withdrawal request.
   */
  trading_account_id: string;
  /**
   * The money in the trading currency.
   */
  trading_money: AmountCurrencyResponse;
  confirmation_status: EnumConfirmationStatus;
  verification_type: EnumVerificationType;
  /**
   * Timestamp of when the withdrawal request was created.
   */
  created_at: Date;
  /**
   * The time limit for the withdrawal request in minutes, measured from created_at.
   */
  time_limit_in_minutes: number;
};

export type CalculatedTransactions = {
  /**
   * The total money that has been withdrawn from the Trading Account in trading currency.
   */
  total_money: AmountCurrencyResponse;
  /**
   * The money that is left on the Trading Account in trading currency.
   */
  remaining_money: AmountCurrencyResponse;
  /**
   * The available balance before the withdrawal from the Trading Account in trading currency. Sum of total_amount + remaining_amount.
   */
  available_money: AmountCurrencyResponse;
  /**
   * The date and time when the exchange rate needs to be updated.
   */
  exchange_rate_valid_until?: Date;
  /**
   * List of transaction breakdown for each SPA.
   */
  breakdowns: Array<SavedPaymentAccountCalculatedTransactions>;
};

export type CustomerDocumentResponse = {
  /**
   * Document friendly name
   */
  name: string;
  /**
   * Upload status
   */
  status: string;
  /**
   * S3 Download URL
   */
  download_url?: string;
  /**
   * Upload timestamp
   */
  created_at: string;
};

export type DocumentCreationRequest = {
  /**
   * Name of the document
   */
  name: string;
  /**
   * SHA256 checksum of the document
   */
  checksum: string;
};

export type DocumentCreationResponse = {
  /**
   * Presigned S3 upload URL
   */
  presigned_url: string;
  /**
   * ID of the saved Document record
   */
  document_id: string;
  /**
   * Required form fields for presigned POST upload
   */
  fields: {
    [key: string]: string;
  };
};

export type AmountCurrencyRequest = {
  /**
   * The amount of money.
   */
  amount: string;
  /**
   * The currency code.
   */
  code: string;
};

/**
 * Saved payment account fields
 */
export type SavedPaymentAccountFields = {
  [key: string]: unknown;
};

export type ApmDepositConfirmRequest = {
  paypal_request?: PayPalDepositConfirmRequest;
};

/**
 * Machine readable i18n key
 */
export const EnumErrorKey = {
  CommonBadRequest: "common.bad_request",
  CommonInvalidRequiredField: "common.invalid_required_field",
  CommonInternalServerError: "common.internal_server_error",
  AuthAuthenticationFailed: "auth.authentication_failed",
  AuthUnauthorized: "auth.unauthorized",
  CashierInternalTransferCannotBeCreated:
    "cashier.internal_transfer.cannot_be_created",
  CashierExchangeRateCannotBeRetrieved:
    "cashier.exchange_rate.cannot_be_retrieved",
  CashierCurrenciesCannotBeRetrieved: "cashier.currencies.cannot_be_retrieved",
  CashierInternalCodesCannotBeRetrieved:
    "cashier.internal_codes.cannot_be_retrieved",
  CashierPageAlertCannotBeRetrieved: "cashier.page_alert.cannot_be_retrieved",
  CashierTransactionsCannotBeRetrieved:
    "cashier.transactions.cannot_be_retrieved",
  CashierSumOfTransactionsCannotBeRetrieved:
    "cashier.sum_of_transactions.cannot_be_retrieved",
  CashierSavedPaymentAccountCardExpiryCannotBeUpdated:
    "cashier.saved_payment_account.card_expiry_cannot_be_updated",
  CashierSavedPaymentAccountNotFound: "cashier.saved_payment_account.not_found",
  CashierSavedPaymentAccountNewSpaMatchedSpaWithDeletionRequest:
    "cashier.saved_payment_account.new_spa_matched_spa_with_deletion_request",
  CashierSavedPaymentAccountNewSpaMatchedSpaWithInvalidStatus:
    "cashier.saved_payment_account.new_spa_matched_spa_with_invalid_status",
  CashierTransactionStatusCannotBeRetrieved:
    "cashier.transaction_status.cannot_be_retrieved",
  CashierTransactionStatusNotFound: "cashier.transaction_status.not_found",
  CashierDocumentCannotBeRetrieved: "cashier.document.cannot_be_retrieved",
  CashierDocumentNotFound: "cashier.document.not_found",
  CashierDocumentCannotBeCreated: "cashier.document.cannot_be_created",
  CashierDocumentStatusCannotBeUpdated:
    "cashier.document.status.cannot_be_updated",
  CashierSessionTokenCannotBeRetrieved:
    "cashier.session_token.cannot_be_retrieved",
  DepositTransactionCannotBeStarted: "deposit.transaction_cannot_be_started",
  DepositTransactionCannotBeUpdated: "deposit.transaction_cannot_be_updated",
  DepositTransactionNotPending: "deposit.transaction_not_pending",
  DepositTransactionNotFound: "deposit.transaction_not_found",
  DepositInvalidFormFieldData: "deposit.invalid_form_field_data",
  DepositPaymentMethodsCannotBeRetrieved:
    "deposit.payment_methods_cannot_be_retrieved",
  DepositPaymentMethodCannotBeFound: "deposit.payment_method_cannot_be_found",
  DepositPaymentMethodGroupCannotBeFound:
    "deposit.payment_method_group_cannot_be_found",
  WithdrawalPaymentMethodsCannotBeRetrieved:
    "withdrawal.payment_methods_cannot_be_retrieved",
  DepositSavedPaymentAccountDeletionRequestCannotBeCreated:
    "deposit.saved_payment_account.deletion_request_cannot_be_created",
  DepositSavedPaymentAccountLastAccountCannotBeRetrieved:
    "deposit.saved_payment_account.last_account_cannot_be_retrieved",
  DepositBinCodeBlocked: "deposit.bin_code.blocked",
  DepositBinCodeCannotBeVerified: "deposit.bin_code.cannot_be_verified",
  DepositPspError: "deposit.psp_error",
  DepositSavedPaymentAccountInvalidStatus:
    "deposit.saved_payment_account.invalid_status",
  WithdrawalBinCodeBlocked: "withdrawal.bin_code.blocked",
  WithdrawalBinCodeCannotBeVerified: "withdrawal.bin_code.cannot_be_verified",
  WithdrawalInvalidFormFieldData: "withdrawal.invalid_form_field_data",
  WithdrawalTransactionCannotBeCreated:
    "withdrawal.transaction.cannot_be_created",
  WithdrawalTransactionCannotBeExecuted:
    "withdrawal.transaction.cannot_be_executed",
  WithdrawalSavedPaymentAccountLastAccountCannotBeRetrieved:
    "withdrawal.saved_payment_account.last_account_cannot_be_retrieved",
  WithdrawalTradingAccountCannotBeRetrieved:
    "withdrawal.trading_account_cannot_be_retrieved",
  WithdrawalSavedPaymentAccountRefundBalanceCannotBeRetrieved:
    "withdrawal.saved_payment_account.refund_balance_cannot_be_retrieved",
  WithdrawalSavedPaymentAccountSummariesRefundCannotBeRetrieved:
    "withdrawal.saved_payment_account.summaries_refund_cannot_be_retrieved",
  WithdrawalSavedPaymentAccountSummariesProfitCannotBeRetrieved:
    "withdrawal.saved_payment_account.summaries_profit_cannot_be_retrieved",
  WithdrawalTransactionsCannotBeFound:
    "withdrawal.transactions.cannot_be_found",
  WithdrawalRequestNotVerified: "withdrawal.request.not_verified",
  WithdrawalRequestCannotBeFound: "withdrawal.request.cannot_be_found",
  WithdrawalRequestWaitingForEmailCooldown:
    "withdrawal.request.waiting_for_email_cooldown",
  TransferExchangeRateCannotBeRetrieved:
    "transfer.exchange_rate.cannot_be_retrieved",
  TransferTransactionCannotBeCreated: "transfer.transaction_cannot_be_created",
  TransferTransactionCannotBeStarted: "transfer.transaction_cannot_be_started",
  TransferTradingAccountsCannotBeRetrieved:
    "transfer.trading_accounts_cannot_be_retrieved",
  TransferInsufficientFunds: "transfer.insufficient_funds",
  WithdrawalInsufficientFunds: "withdrawal.insufficient_funds",
  WithdrawalAmountBelowMinimumLimit: "withdrawal.amount_below_minimum_limit",
  WithdrawalProhibitedForTempAccounts:
    "withdrawal.prohibited_for_temp_accounts",
  WithdrawalProhibitedForDemoAccounts:
    "withdrawal.prohibited_for_demo_accounts",
  WithdrawalVerificationFailed: "withdrawal.verification_failed",
  WithdrawalBankStatementRequired: "withdrawal.bank_statement_required",
  PspPaymentMethodNotSupported: "psp.payment_method_not_supported",
} as const;

/**
 * Machine readable i18n key
 */
export type EnumErrorKey = (typeof EnumErrorKey)[keyof typeof EnumErrorKey];

export type CashierTradingAccount = {
  /**
   * The PNX PK of the trading account.
   */
  id: string;
  /**
   * The SCA ID of the trading platform
   */
  accountId: number;
  /**
   * Trading Platform Login ID
   */
  accountLoginId: string;
  /**
   * Default name of the trading account
   */
  accountName: string;
  /**
   * Customizable name of the trading account
   */
  accountNickname?: string;
  /**
   * Type of the trading account
   */
  accountType: EnumTradingAccountType;
  /**
   * The name of the trading platform. E.g. Pepperstone, MT5
   */
  tradingPlatform: EnumTradingPlatform;
  /**
   * The currency of the trading account.
   */
  currency: CurrencyPrimitive;
  /**
   * The balance of the trading account in safe decimal format
   */
  balance: AmountCurrencyResponse;
  /**
   * Whether the trading account is enabled
   */
  isEnabled: boolean;
  /**
   * Whether the trading account is fundable
   */
  isFundable: boolean;
  /**
   * Whether the trading account is temporary
   */
  isTemporary: boolean;
};

/**
 * Legal entity types associated with the customer.
 */
export type LegalEntities = Array<string>;

export type CashierTransactionHistorySavedPaymentAccount = {
  /**
   * The URL of the logo associated with the saved payment account.
   */
  logo_url: string;
  /**
   * Payment method name.
   */
  name: string;
  /**
   * The detail identifies the saved payment account to the customer.
   * There are multiple types of saved payment accounts, such as credit cards, bank accounts, etc.
   * The detail is used to provide additional information about the payment method,
   * such as the last four digits of a credit card or email address for APMs like PayPal.
   *
   */
  detail: string;
  /**
   * Additional information about the saved payment account,
   * such as the expiration date for credit cards,
   * or last 4 digits of bank accounts etc..
   *
   */
  secondary_detail?: string;
};

/**
 * The status of the transaction that shown on Cashier
 */
export const EnumCashierTxStatus = {
  /**
   * CashierTxUnsuccessful
   */
  CashierTxUnsuccessful: "Unsuccessful",
  /**
   * CashierTxPending
   */
  CashierTxPending: "Pending",
  /**
   * CashierTxComplete
   */
  CashierTxComplete: "Complete",
  /**
   * CashierTxRequested
   */
  CashierTxRequested: "Requested",
  /**
   * CashierTxProcessing
   */
  CashierTxProcessing: "Processing",
  /**
   * CashierTxCancelled
   */
  CashierTxCancelled: "Cancelled",
} as const;

/**
 * The status of the transaction that shown on Cashier
 */
export type EnumCashierTxStatus =
  (typeof EnumCashierTxStatus)[keyof typeof EnumCashierTxStatus];

export type CashierTransactionTimelineStep = {
  /**
   * Timeline step type. See https://pepperstone.atlassian.net/wiki/spaces/PN/pages/3753902594/WD+DP+history+details+page+-+status+mapping
   */
  step_type: EnumTransactionTimelineStepType;
  /**
   * Timeline step status. See https://pepperstone.atlassian.net/wiki/spaces/PN/pages/3753902594/WD+DP+history+details+page+-+status+mapping
   */
  step_status: EnumTransactionTimelineStepStatus;
  /**
   * date and time when the record was created, or null when future state
   */
  timestamp?: Date;
  /**
   * Estimated completion time in days
   */
  estimated_completion?: number;
};

export type CashierTradingAccountMargin = {
  /**
   * The PNX PK of the trading account.
   */
  id: string;
  /**
   * The SCA ID of the trading platform
   */
  accountId: number;
  /**
   * Trading Platform Login ID
   */
  accountLoginId: string;
  /**
   * Default name of the trading account
   */
  accountName: string;
  /**
   * Customizable name of the trading account
   */
  accountNickname?: string;
  /**
   * Type of the trading account
   */
  accountType: EnumTradingAccountType;
  /**
   * The name of the trading platform. E.g. Pepperstone, MT5
   */
  tradingPlatform: EnumTradingPlatform;
  /**
   * The currency of the trading account.
   */
  currency: CurrencyPrimitive;
  /**
   * The free margin of the trading account in safe decimal format
   */
  margin: AmountCurrencyResponse;
  /**
   * The balance of the trading account in safe decimal format
   */
  balance: AmountCurrencyResponse;
  /**
   * Whether the trading account is fundable
   */
  isFundable: boolean;
};

/**
 * The status of the transaction
 */
export const EnumTransactionStatus = {
  /**
   * EnumStatusInitiated
   */
  EnumStatusInitiated: "initiated",
  /**
   * EnumStatusPending
   */
  EnumStatusPending: "pending",
  /**
   * EnumStatusFailed
   */
  EnumStatusFailed: "failed",
  /**
   * EnumStatusCancelled
   */
  EnumStatusCancelled: "cancelled",
  /**
   * EnumStatusTransferCompleted
   */
  EnumStatusTransferCompleted: "completed",
  /**
   * EnumStatusRequested
   */
  EnumStatusRequested: "requested",
  /**
   * EnumStatusInReview
   */
  EnumStatusInReview: "in_review",
  /**
   * EnumStatusProcessing
   */
  EnumStatusProcessing: "processing",
  /**
   * EnumStatusPendingOnHold
   */
  EnumStatusPendingOnHold: "pending_on_hold",
  /**
   * EnumStatusProcessingOnHold
   */
  EnumStatusProcessingOnHold: "processing_on_hold",
  /**
   * EnumStatusProcessed
   */
  EnumStatusProcessed: "processed",
  /**
   * EnumStatusReview
   */
  EnumStatusReview: "review",
  /**
   * EnumStatusValidating
   */
  EnumStatusValidating: "validating",
  /**
   * EnumStatusSuccessful
   */
  EnumStatusSuccessful: "successful",
} as const;

/**
 * The status of the transaction
 */
export type EnumTransactionStatus =
  (typeof EnumTransactionStatus)[keyof typeof EnumTransactionStatus];

export type LastUsedPaymentMethod = {
  /**
   * Previous money
   */
  money: AmountCurrencyResponse;
  /**
   * The unique identifier of the payment method.
   */
  payment_method_id: string;
  /**
   * The unique identifier of the payment method group.
   */
  payment_method_group_id?: string;
  /**
   * The details of the payment account used for last transaction.
   */
  payment_account_details: {
    [key: string]: unknown;
  };
};

export type CashierPaymentMethodArrangementItem =
  | CashierPaymentMethod
  | CashierPaymentMethodGroup;

export type CashierPaymentMethod = {
  /**
   * The unique identifier of the payment method.
   */
  id: string;
  /**
   * Name of the payment method
   */
  display_name: string;
  /**
   * Category of the payment method
   */
  payment_method_category: string;
  /**
   * Subcategory of the payment method
   */
  payment_method_subcategory?: string;
  status: EnumPaymentMethodState;
  disabled_reason?: EnumDisabledReason;
  /**
   * URL to the logo of the payment method
   */
  logo_url: string;
  downtime?: DowntimeProperties;
  base_settings: CashierPaymentMethodBaseSettings;
  /**
   * Configuration settings per available currency for the payment method.
   */
  settings: {
    [key: string]: CashierPaymentMethodConfigurationSettings;
  };
  action_type: EnumActionType;
  form: FormFieldsByLicense;
  /**
   * PSP settings mapped by license ID. For bank_transfer payment methods, only bank_details and account_details are returned (general_fields excluded for security). In addition to license-specific keys, the backend may also populate global or general PSP settings under the special `default` license key, which apply when no license-specific override is available
   */
  psp_settings: {
    [key: string]: CashierPspSettings;
  };
  /**
   * PSP fields for the payment method
   */
  psp_fields: PaymentMethodPspFieldsByLicense;
  message?: MessageProperties;
  /**
   * Exchange rate is hidden flag of the payment method
   */
  exchange_rate_is_hidden: boolean;
  saved_payment_accounts?: Array<SavedPaymentAccountIdAndFields>;
  bank_statement_upload_config?: BankStatementUploadConfig;
  /**
   * The processing currencies of the payment method.
   */
  processing_currencies?: Array<string>;
};

/**
 * The availability status of the payment method group.
 */
export const EnumPaymentMethodGroupState = {
  /**
   * EnumPaymentMethodGroupStateActive
   */
  EnumPaymentMethodGroupStateActive: "active",
  /**
   * EnumPaymentMethodGroupStateInactive
   */
  EnumPaymentMethodGroupStateInactive: "inactive",
  /**
   * EnumPaymentMethodGroupStatePartiallyActive
   */
  EnumPaymentMethodGroupStatePartiallyActive: "partially_active",
  /**
   * EnumPaymentMethodGroupStateOffline
   */
  EnumPaymentMethodGroupStateOffline: "offline",
} as const;

/**
 * The availability status of the payment method group.
 */
export type EnumPaymentMethodGroupState =
  (typeof EnumPaymentMethodGroupState)[keyof typeof EnumPaymentMethodGroupState];

/**
 * The type of the transaction.
 */
export const EnumTransactionType = {
  /**
   * EnumTransactionTypeDeposit
   */
  EnumTransactionTypeDeposit: "deposit",
  /**
   * EnumTransactionTypePayout
   */
  EnumTransactionTypePayout: "payout",
  /**
   * EnumTransactionTypeRefund
   */
  EnumTransactionTypeRefund: "refund",
  /**
   * EnumTransactionTypeInternalTransfer
   */
  EnumTransactionTypeInternalTransfer: "internal_transfer",
} as const;

/**
 * The type of the transaction.
 */
export type EnumTransactionType =
  (typeof EnumTransactionType)[keyof typeof EnumTransactionType];

/**
 * A payment method within a payment method group.
 */
export type PaymentMethodGroupMember = {
  /**
   * The unique identifier of the payment method.
   */
  id: string;
  /**
   * The name of the payment method.
   */
  method_name: string;
  /**
   * The display name of the payment method.
   */
  display_name: string;
  /**
   * URL to the logo of the payment method
   */
  logo_url: string;
  status: EnumPaymentMethodState;
  /**
   * The order of the payment method.
   */
  sort_order: number;
  /**
   * The name of the payment method gateway.
   */
  gateway_name: string;
  /**
   * The name of the payment method category.
   */
  category_name: string;
  /**
   * The name of the payment method subcategory.
   */
  subcategory_name?: string;
  /**
   * The processing currencies of the payment method.
   */
  processing_currencies: Array<string>;
  /**
   * The allowed licenses of the payment method.
   */
  allowed_licenses: Array<string>;
  /**
   * The allowed transaction types of the payment method.
   */
  allowed_transaction_types: Array<EnumTransactionType>;
  availability_status: EnumPaymentMethodState;
};

export type CurrencyConversion = {
  /**
   * The money in the ledger's currency.
   */
  ledger_money?: AmountCurrencyResponse;
  trading_money: AmountCurrencyResponse;
  /**
   * The rate at which the currency was converted from the ledger_money to the trading_money
   */
  rate: string;
};

/**
 * Summary information for a saved payment account refund, grouped by saved payment account ID.
 */
export type SavedPaymentAccountRefundSummary = {
  /**
   * The unique identifier of the saved payment account.
   */
  id?: string | null;
  /**
   * The detail identifies the saved payment account to the customer.
   * There are multiple types of saved payment accounts, such as credit cards, bank accounts, etc.
   * The detail is used to provide additional information about the payment method,
   * such as the last four digits of a credit card or email address for APMs like PayPal.
   *
   */
  detail: string;
  /**
   * Additional information about the saved payment account,
   * such as the expiration date for credit cards,
   * or last 4 digits of bank accounts etc..
   *
   */
  secondary_detail?: string;
  /**
   * Payment method name.
   */
  name: string;
  /**
   * The URL of the logo associated with the saved payment account.
   */
  logo_url: string;
  /**
   * The unique identifier of the payment method.
   */
  payment_method_id: string;
  /**
   * The unique identifier of the deposit payment method.
   */
  deposit_payment_method_id?: string;
  /**
   * Fee information for this refund entry.
   */
  fee: FeeSettingsResponse;
  /**
   * The availability status of the payment method for this refund saved payment account.
   */
  status?: EnumPaymentMethodState;
  /**
   * The reason why this refund saved payment account is disabled (when status is offline).
   */
  disabled_reason?: EnumDisabledReason;
  /**
   * Sub-items containing minimum and maximum amounts per ledger.
   */
  ledger_entries: Array<RefundLedgerEntry>;
  /**
   * List of currencies with exchange rates, when it is allowed for customer to choose processing currency.
   */
  processing_currencies: Array<CurrencyWithRate>;
  /**
   * Information message of the payment method, sourced from the refund network settings when refunds are
   * enabled for the payment method, otherwise from the payout network settings.
   *
   */
  info_message: string;
  /**
   * Expected processing time of the payment method, sourced from the refund network settings when refunds
   * are enabled for the payment method, otherwise from the payout network settings.
   *
   */
  expected_processing_time: string;
  /**
   * The minimum amount that can be withdrawn to this saved payment account. Validated against the sum of entered amounts for all ledger entries.
   */
  minimum_amount?: AmountCurrencyResponse;
};

/**
 * The fee settings response of a payment method.
 */
export type FeeSettingsResponse = {
  type: EnumFeeType;
  /**
   * The value of the fee.
   */
  value: AmountCurrencyResponse;
};

/**
 * The availability status of the payment method.
 */
export const EnumPaymentMethodState = {
  /**
   * EnumPaymentMethodStateActive
   */
  EnumPaymentMethodStateActive: "active",
  /**
   * EnumPaymentMethodStateInactive
   */
  EnumPaymentMethodStateInactive: "inactive",
  /**
   * EnumPaymentMethodStateOffline
   */
  EnumPaymentMethodStateOffline: "offline",
} as const;

/**
 * The availability status of the payment method.
 */
export type EnumPaymentMethodState =
  (typeof EnumPaymentMethodState)[keyof typeof EnumPaymentMethodState];

/**
 * The reason why payment method has disabled status.
 */
export const EnumDisabledReason = {
  /**
   * EnumDisabledReasonManual
   */
  EnumDisabledReasonManual: "manual",
  /**
   * EnumDisabledReasonDowntime
   */
  EnumDisabledReasonDowntime: "downtime",
  /**
   * EnumDisabledReasonTempAccount
   */
  EnumDisabledReasonTempAccount: "temp_account",
  /**
   * EnumDisabledReasonTechnicalIssue
   */
  EnumDisabledReasonTechnicalIssue: "technical_issue",
} as const;

/**
 * The reason why payment method has disabled status.
 */
export type EnumDisabledReason =
  (typeof EnumDisabledReason)[keyof typeof EnumDisabledReason];

export type CurrencyWithRate = {
  /**
   * The code of the currency
   */
  code: string;
  /**
   * The exchange rate of the currency against a trading account currency.
   */
  rate: string;
  /**
   * The minimum amount that can be withdrawn in this processing currency.
   */
  minimum_amount: AmountCurrencyResponse;
};

/**
 * The status of the document upload.
 */
export const EnumDocumentUploadStatus = {
  /**
   * EnumDocumentUploadStatusPending
   */
  EnumDocumentUploadStatusPending: "pending",
  /**
   * EnumDocumentUploadStatusDone
   */
  EnumDocumentUploadStatusDone: "done",
  /**
   * EnumDocumentUploadStatusError
   */
  EnumDocumentUploadStatusError: "error",
} as const;

/**
 * The status of the document upload.
 */
export type EnumDocumentUploadStatus =
  (typeof EnumDocumentUploadStatus)[keyof typeof EnumDocumentUploadStatus];

export type SavedPaymentAccountRefundAmounts = {
  /**
   * The unique identifier of the saved payment account.
   */
  id: string;
  /**
   * The currency in which the transaction will be processed. Only for bank transfer transactions.
   */
  selected_currency?: string;
  /**
   * Amounts for refund for SavedPaymentAccount.
   */
  amounts: Array<AmountCurrencyRequest>;
};

export type SavedPaymentAccountProfitAmount = {
  /**
   * The unique identifier of the saved payment account.
   */
  id: string;
  /**
   * The currency in which the transaction will be processed. Only for bank transfer transactions.
   */
  selected_currency?: string;
  /**
   * Amount for SavedPaymentAccount in the currency of selected trading account.
   */
  amount_with_currency: AmountCurrencyRequest;
};

/**
 * The type of user verification.
 */
export const EnumVerificationType = {
  /**
   * EnumVerificationTypeOTP
   */
  EnumVerificationTypeOtp: "otp",
  /**
   * EnumVerificationTypeEmail
   */
  EnumVerificationTypeEmail: "email",
  /**
   * EnumVerificationTypeBackoffice
   */
  EnumVerificationTypeBackoffice: "backoffice",
} as const;

/**
 * The type of user verification.
 */
export type EnumVerificationType =
  (typeof EnumVerificationType)[keyof typeof EnumVerificationType];

/**
 * The status of the withdrawal request confirmation.
 */
export const EnumConfirmationStatus = {
  /**
   * EnumConfirmationStatusApproved
   */
  EnumConfirmationStatusApproved: "approved",
  /**
   * EnumConfirmationStatusUnapproved
   */
  EnumConfirmationStatusUnapproved: "unapproved",
  /**
   * EnumConfirmationStatusCancelled
   */
  EnumConfirmationStatusCancelled: "cancelled",
} as const;

/**
 * The status of the withdrawal request confirmation.
 */
export type EnumConfirmationStatus =
  (typeof EnumConfirmationStatus)[keyof typeof EnumConfirmationStatus];

export type SavedPaymentAccountCalculatedTransactions = {
  /**
   * The unique identifier of the saved payment account.
   */
  id: string;
  /**
   * The URL of the logo associated with the saved payment account.
   */
  logo_url: string;
  /**
   * Payment method name.
   */
  name: string;
  /**
   * The detail identifies the saved payment account to the customer.
   * There are multiple types of saved payment accounts, such as credit cards, bank accounts, etc.
   * The detail is used to provide additional information about the payment method,
   * such as the last four digits of a credit card or email address for APMs like PayPal.'
   *
   */
  detail: string;
  /**
   * The exchange rate between the trading account currency and the SPA processing currency.
   * The exchange rate is used to calculate the amount in the SPA processing currency.
   * eg. 100 JPY = 23.60 HUF, exchange_rate_unit = 100, currency = JPY, exchange_rate = 23.60, processing_currency = HUF
   *
   */
  exchange_rate?: number;
  /**
   * The exchange rate between the trading account currency and the SPA processing currency.
   * The trading account currency amount exchanged (1, 100, 1000, etc.) to the SPA processing currency amount.
   * eg. 100 JPY = 23.60 HUF, exchange_rate_unit = 100, currency = JPY, exchange_rate = 23.60, processing_currency = HUF
   *
   */
  exchange_rate_unit?: number;
  /**
   * The total money that is being sent to SPA, after fees (you receive) in trading currency.
   */
  money: AmountCurrencyResponse;
  /**
   * The total money that is being sent to SPA, after fees (you receive) in processing currency.
   */
  money_in_processing_currency?: AmountCurrencyResponse;
  /**
   * The total amount that is being sent to SPA, before fees (deducted from trading account) in trading currency.
   */
  money_total?: AmountCurrencyResponse;
  /**
   * The type of fee.
   */
  fee_type?: EnumFeeType;
  /**
   * The value of the fee.
   */
  fee_value?: AmountCurrencyResponse;
  /**
   * The amount of the fee in trading currency.
   */
  fee_total?: AmountCurrencyResponse;
  /**
   * The amount of the fee in processing currency.
   */
  fee_total_in_processing_currency?: AmountCurrencyResponse;
  /**
   * Sum all profit transactions.
   */
  profits_total?: AmountCurrencyResponse;
  /**
   * Sum all profit transactions in processing currency.
   */
  profits_total_in_processing_currency?: AmountCurrencyResponse;
  /**
   * List of refund transactions.
   */
  refunds?: Array<SavedPaymentAccountTransactionItem>;
  /**
   * List of profit transactions.
   */
  profits?: Array<SavedPaymentAccountTransactionItem>;
};

export type PayPalDepositConfirmRequest = {
  /**
   * PayPal nonce to finalize deposit.
   */
  nonce: string;
  /**
   * PayPal Device data.
   */
  device_data: string;
  /**
   * PayPal User Email.
   */
  payer_email: string;
  /**
   * PayPal User First name.
   */
  first_name: string;
  /**
   * PayPal User Last name.
   */
  last_name: string;
  /**
   * PayPal User ID.
   */
  payer_id: string;
  /**
   * PayPal User Phone number.
   */
  phone: string;
  /**
   * PayPal User Country Code.
   */
  country_code: string;
  /**
   * PayPal User Address line.
   */
  address_line: string;
  /**
   * PayPal User City.
   */
  city: string;
  /**
   * PayPal User State.
   */
  state: string;
  /**
   * PayPal User Postal Code.
   */
  postal_code: string;
  /**
   * PayPal User Billing Country Code.
   */
  billing_country_code: string;
};

/**
 * Type of the trading account
 */
export const EnumTradingAccountType = {
  /**
   * EnumTradingAccountTypeLive
   */
  EnumTradingAccountTypeLive: "Live",
  /**
   * EnumTradingAccountTypeDemo
   */
  EnumTradingAccountTypeDemo: "Demo",
  /**
   * EnumTradingAccountTypeRebate
   */
  EnumTradingAccountTypeRebate: "Rebate",
  /**
   * EnumTradingAccountTypeStandard
   */
  EnumTradingAccountTypeStandard: "Standard",
  /**
   * EnumTradingAccountTypeRazor
   */
  EnumTradingAccountTypeRazor: "Razor",
  /**
   * EnumTradingAccountTypeTest
   */
  EnumTradingAccountTypeTest: "Test",
  /**
   * EnumTradingAccountTypeTemp
   */
  EnumTradingAccountTypeTemp: "Temp",
  /**
   * EnumTradingAccountTypeIslamic
   */
  EnumTradingAccountTypeIslamic: "Islamic",
  /**
   * EnumTradingAccountTypeMAMMaster
   */
  EnumTradingAccountTypeMamMaster: "MAM Master",
  /**
   * EnumTradingAccountTypeMAMSlave
   */
  EnumTradingAccountTypeMamSlave: "MAM Slave",
} as const;

/**
 * Type of the trading account
 */
export type EnumTradingAccountType =
  (typeof EnumTradingAccountType)[keyof typeof EnumTradingAccountType];

/**
 * Type of the CashierTransactionTimelineStep.
 * https://pepperstone.atlassian.net/wiki/spaces/PN/pages/3753902594/WD+DP+history+details+page+-+status+mapping#Deposit-history-details-page---status-mapping
 *
 * For Withdrawal:
 * - RequestSubmitted
 * - PendingReview
 * - Processing
 * - Complete
 * - Cancelled
 * - CancelledDueInactivity
 * - CancelledByUser
 * - Unsuccessful
 *
 * For Deposit:
 * - RequestSubmitted
 * - PendingForFunds
 * - PendingReview
 * - Complete
 * - Unsuccessful
 *
 */
export const EnumTransactionTimelineStepType = {
  /**
   * EnumTransactionTimelineStepTypeRequestSubmitted
   */
  EnumTransactionTimelineStepTypeRequestSubmitted: "request_submitted",
  /**
   * EnumTransactionTimelineStepTypePendingReview
   */
  EnumTransactionTimelineStepTypePendingReview: "pending_review",
  /**
   * EnumTransactionTimelineStepTypeProcessing
   */
  EnumTransactionTimelineStepTypeProcessing: "processing",
  /**
   * EnumTransactionTimelineStepTypeComplete
   */
  EnumTransactionTimelineStepTypeComplete: "complete",
  /**
   * EnumTransactionTimelineStepTypeCancelled
   */
  EnumTransactionTimelineStepTypeCancelled: "cancelled",
  /**
   * EnumTransactionTimelineStepTypeCancelledDueInactivity
   */
  EnumTransactionTimelineStepTypeCancelledDueInactivity:
    "cancelled_due_inactivity",
  /**
   * EnumTransactionTimelineStepTypeCancelledByUser
   */
  EnumTransactionTimelineStepTypeCancelledByUser: "cancelled_by_user",
  /**
   * EnumTransactionTimelineStepTypeUnsuccessful
   */
  EnumTransactionTimelineStepTypeUnsuccessful: "unsuccessful",
  /**
   * EnumTransactionTimelineStepTypePendingForFunds
   */
  EnumTransactionTimelineStepTypePendingForFunds: "pending_for_funds",
} as const;

/**
 * Type of the CashierTransactionTimelineStep.
 * https://pepperstone.atlassian.net/wiki/spaces/PN/pages/3753902594/WD+DP+history+details+page+-+status+mapping#Deposit-history-details-page---status-mapping
 *
 * For Withdrawal:
 * - RequestSubmitted
 * - PendingReview
 * - Processing
 * - Complete
 * - Cancelled
 * - CancelledDueInactivity
 * - CancelledByUser
 * - Unsuccessful
 *
 * For Deposit:
 * - RequestSubmitted
 * - PendingForFunds
 * - PendingReview
 * - Complete
 * - Unsuccessful
 *
 */
export type EnumTransactionTimelineStepType =
  (typeof EnumTransactionTimelineStepType)[keyof typeof EnumTransactionTimelineStepType];

/**
 * Status of the CashierTransactionTimelineStep.
 */
export const EnumTransactionTimelineStepStatus = {
  /**
   * EnumTransactionTimelineStepStatusInProgress
   */
  EnumTransactionTimelineStepStatusInProgress: "in_progress",
  /**
   * EnumTransactionTimelineStepStatusCompleted
   */
  EnumTransactionTimelineStepStatusCompleted: "completed",
  /**
   * EnumTransactionTimelineStepStatusFailed
   */
  EnumTransactionTimelineStepStatusFailed: "failed",
  /**
   * EnumTransactionTimelineStepStatusCancelled
   */
  EnumTransactionTimelineStepStatusCancelled: "cancelled",
  /**
   * EnumTransactionTimelineStepStatusNotStarted
   */
  EnumTransactionTimelineStepStatusNotStarted: "not_started",
} as const;

/**
 * Status of the CashierTransactionTimelineStep.
 */
export type EnumTransactionTimelineStepStatus =
  (typeof EnumTransactionTimelineStepStatus)[keyof typeof EnumTransactionTimelineStepStatus];

export type CashierPaymentMethodGroup = {
  /**
   * Unique identifier for the payment method group
   */
  id: string;
  /**
   * Name of the payment method
   */
  display_name: string;
  /**
   * URL to the logo of the payment method
   */
  logo_url: string;
  payment_methods: Array<CashierPaymentMethod>;
};

/**
 * The downtime settings of a payment method.
 */
export type DowntimeProperties = {
  /**
   * The start time of the downtime (HH:MM)
   */
  start: string;
  /**
   * The duration of the downtime (e.g. 1h30m)
   */
  duration: string;
  /**
   * The available time of the method (oposite of the downtime) e.g. 9am - 5pm
   */
  available: string;
};

export type CashierPaymentMethodBaseSettings =
  | DepositBaseSettings
  | WithdrawalBaseSettings;

/**
 * The settings of a payment method configuration.
 */
export type CashierPaymentMethodConfigurationSettings =
  PaymentMethodProcessingCurrencyLimitResponse & {
    trading_currency: PmConfigTradingCurrencyLimitResponse;
  };

/**
 * The form settings of a payment method. In this map, a key of ("default") for id.LicenseID represents default values that apply when no specific license is associated. All other keys correspond to configurations for a particular license.
 */
export type FormFieldsByLicense = {
  [key: string]: FormFields;
};

/**
 * Cashier-specific PSP settings for bank_transfer payment methods, containing only bank and account details (excludes general_fields for security)
 */
export type CashierPspSettings = {
  bank_details?: PspBankDetails;
  account_details?: Array<PspAccountDetail>;
};

/**
 * The PSP settings of a payment method by license. In this map, a key of zero UUID ("00000000-0000-0000-0000-000000000000") for id.LicenseID represents default values that apply when no specific license is associated. All other keys correspond to configurations for a particular license.
 */
export type PaymentMethodPspFieldsByLicense = {
  [key: string]: PaymentMethodPspFields;
};

/**
 * The message settings of a payment method.
 */
export type MessageProperties = {
  /**
   * The value of alarm message.
   */
  alarm: string | null;
  /**
   * The value of alarm notification.
   */
  notification: string | null;
};

export type SavedPaymentAccountIdAndFields = {
  /**
   * The unique identifier of the saved payment account.
   */
  id: string;
  /**
   * The detail identifies the saved payment account to the customer.
   * There are multiple types of saved payment accounts, such as credit cards, bank accounts, etc.
   * The detail is used to provide additional information about the payment method,
   * such as the last four digits of a credit card or email address for APMs like PayPal.
   *
   */
  detail: string;
  /**
   * Additional information about the saved payment account,
   * such as the expiration date for credit cards,
   * or last 4 digits of bank accounts etc..
   *
   */
  secondary_detail?: string;
  saved_payment_account_fields?: SavedPaymentAccountFields;
  /**
   * The payment token associated with the saved payment account, if applicable.
   */
  payment_token?: string;
  /**
   * Indicates whether the card has expired.
   */
  is_expired?: boolean;
  /**
   * IsPending Indicates account is under review for PayPal
   */
  is_pending?: boolean;
};

/**
 * Configurable business rules for document upload requirements during withdrawal. Presence of this object on a payment method means document upload is enabled.
 */
export type BankStatementUploadConfig = {
  /**
   * List of license IDs for which document upload is always mandatory
   */
  mandatory_licenses: Array<string>;
  /**
   * Withdrawal amount threshold in AUD above which document upload becomes mandatory for non-listed licenses
   */
  amount_threshold_aud: AmountCurrencyResponse;
};

/**
 * A ledger entry within a refund account, containing min/max amounts for a specific ledger.
 */
export type RefundLedgerEntry = {
  ledger_id: string;
  /**
   * The minimum amount that can be refunded for this ledger entry.
   */
  minimum_amount: AmountCurrencyResponse;
  /**
   * The maximum amount that can be refunded for this ledger entry.
   */
  maximum_amount: AmountCurrencyResponse;
};

/**
 * The type of the fee.
 */
export const EnumFeeType = {
  /**
   * EnumFeeTypeFixed
   */
  EnumFeeTypeFixed: "fixed" /**
   * EnumFeeTypePercentage
   */,
  EnumFeeTypePercentage: "percentage",
} as const;

/**
 * The type of the fee.
 */
export type EnumFeeType = (typeof EnumFeeType)[keyof typeof EnumFeeType];

export type SavedPaymentAccountTransactionItem = {
  /**
   * The unique identifier of the transaction.
   */
  reference_id?: string;
  /**
   * Payment method name.
   */
  name: string;
  /**
   * The exchange rate between the trading account currency and the transaction processing currency.
   * The exchange rate is used to calculate the amount in the SPA processing currency.
   *
   */
  exchange_rate?: number;
  /**
   * Amount for refund for SavedPaymentAccount in trading currency.
   */
  money: AmountCurrencyResponse;
  /**
   * Amount for refund for SavedPaymentAccount in processing currency.
   */
  money_in_processing_currency?: AmountCurrencyResponse;
  /**
   * The value of the fee in processing currency. The currency matches money_in_processing_currency.
   */
  fee_value?: AmountCurrencyResponse;
};

export type DepositBaseSettings = {
  deposit: PaymentMethodConfigurationNetworkSettingsBase;
};

export type WithdrawalBaseSettings = {
  payout: PaymentMethodConfigurationNetworkSettingsBase;
  refund: PaymentMethodConfigurationNetworkSettings;
};

/**
 * The processing currency limit of a payment method.
 */
export type PaymentMethodProcessingCurrencyLimitResponse = {
  /**
   * The unique identifier of the payment method configuration.
   */
  id: string;
  limit: UnlimitableLimitPairResponse;
  fee: FeeSettingsResponse;
  rounding: EnumExchangeRateRoundingType;
};

/**
 * Settings for a trading currency in a payment method configuration.
 * These settings override the settings set for the processing currency.
 *
 */
export type PmConfigTradingCurrencyLimitResponse = {
  /**
   * The ID of the trading currency limit record.
   */
  id: string;
  exchange_rate: ExchangeRateSettings;
  limit: LimitPairResponse;
  /**
   * The FX spread for the trading currency.
   */
  fx_spread: string;
};

/**
 * The list of fields in the form.
 */
export type FormFields = Array<FormField>;

/**
 * Bank details for bank_transfer payment methods
 */
export type PspBankDetails = {
  /**
   * Account holder name
   */
  account_name?: string;
  /**
   * Bank name
   */
  bank_name?: string;
  /**
   * Bank address
   */
  bank_address?: string;
  /**
   * SWIFT/BIC code
   */
  swift_code?: string;
  /**
   * Sort code (UK)
   */
  sort_code?: string;
  /**
   * Branch code
   */
  branch_code?: string;
  /**
   * Routing number (US)
   */
  routing_number?: string;
};

/**
 * Account details for specific currencies
 */
export type PspAccountDetail = {
  /**
   * Currencies that use this account
   */
  currencies: Array<string>;
  /**
   * Account number
   */
  account_number: string;
  /**
   * IBAN
   */
  iban?: string;
  /**
   * BIC code
   */
  bic?: string;
  /**
   * Routing number
   */
  routing_number?: string;
};

export type PaymentMethodPspFields = Array<PaymentMethodPspField>;

/**
 * The network settings of a payment method configuration.
 */
export type PaymentMethodConfigurationNetworkSettingsBase = {
  /**
   * The enabled status of the payment method.
   */
  enabled: boolean;
  /**
   * The information message of the payment method.
   */
  info_message: string;
  /**
   * The expected processing time of the payment method.
   */
  expected_processing_time: string;
};

export type PaymentMethodConfigurationNetworkSettings =
  PaymentMethodConfigurationNetworkSettingsBase & {
    /**
     * The period in days, within a refund can be initiated, starting from the time of the transaction.
     * For example if the refund period is set to 30, a refund can be initiated up to 30 days after the transaction.
     *
     */
    refund_period?: number;
  };

/**
 * The response limit settings of a payment method.
 */
export type UnlimitableLimitPairResponse = {
  min: UnlimitableLimitResponse;
  max: UnlimitableLimitResponse;
};

/**
 * Rounding method (disabled - no rounding should occur, up - ceil, down - floor). If the exchanged amount has decimals, it decides whether the integer amount be rounded up, down in light of the decimals, or to be left as is with decimals included.
 */
export const EnumExchangeRateRoundingType = {
  /**
   * EnumExchangeRateRoundingTypeDisabled
   */
  EnumExchangeRateRoundingTypeDisabled: "disabled",
  /**
   * EnumExchangeRateRoundingTypeUp
   */
  EnumExchangeRateRoundingTypeUp: "up",
  /**
   * EnumExchangeRateRoundingTypeDown
   */
  EnumExchangeRateRoundingTypeDown: "down",
} as const;

/**
 * Rounding method (disabled - no rounding should occur, up - ceil, down - floor). If the exchanged amount has decimals, it decides whether the integer amount be rounded up, down in light of the decimals, or to be left as is with decimals included.
 */
export type EnumExchangeRateRoundingType =
  (typeof EnumExchangeRateRoundingType)[keyof typeof EnumExchangeRateRoundingType];

/**
 * The exchange rate settings of a payment method.
 */
export type ExchangeRateSettings = {
  type: EnumExchangeRateType;
  /**
   * The value of the exchange rate.
   */
  value?: number;
};

/**
 * The response limit settings for a trading currency of a payment method.
 * These settings can override the limits of the payment method.
 *
 */
export type LimitPairResponse = {
  /**
   * The minimum limit of the payment method.
   */
  min?: AmountCurrencyResponse;
  /**
   * The maximum limit of the payment method.
   */
  max?: AmountCurrencyResponse;
};

/**
 * The field of a form.
 */
export type FormField = {
  /**
   * The HTML ID of the field.
   */
  id: string;
  type: EnumFormFieldType;
  /**
   * The label of the field.
   */
  label: string;
  /**
   * The options of the field, applicable for dropdown form field type.
   */
  options?: {
    [key: string]: unknown;
  };
  option_constraints?: FormFieldOptionConstraints;
  /**
   * The placeholder of the field.
   */
  placeholder: string;
  validation_descriptor: FormFieldValidationDescriptor;
};

/**
 * PSP field of a payment method.
 */
export type PaymentMethodPspField = {
  /**
   * Indicates if the field is dynamic.
   */
  is_dynamic: boolean;
  /**
   * The name of the field.
   */
  name: string;
  /**
   * The value of the field.
   */
  value: string;
  /**
   * The description of the field.
   */
  description: string;
};

/**
 * The response limit value of a payment method.
 */
export type UnlimitableLimitResponse = {
  /**
   * The value of the limit.
   */
  value: AmountCurrencyResponse;
  /**
   * The unlimited status of the limit.
   */
  unlimited: boolean;
};

/**
 * The type of the exchange rate.
 */
export const EnumExchangeRateType = {
  /**
   * EnumExchangeRateTypeFixed
   */
  EnumExchangeRateTypeFixed: "fixed" /**
   * EnumExchangeRateTypeDefault
   */,
  EnumExchangeRateTypeDefault: "default",
} as const;

/**
 * The type of the exchange rate.
 */
export type EnumExchangeRateType =
  (typeof EnumExchangeRateType)[keyof typeof EnumExchangeRateType];

/**
 * The type of the form field.
 */
export const EnumFormFieldType = {
  /**
   * EnumFormFieldTypeButton
   */
  EnumFormFieldTypeButton: "button",
  /**
   * EnumFormFieldTypeCheckbox
   */
  EnumFormFieldTypeCheckbox: "checkbox",
  /**
   * EnumFormFieldTypeColor
   */
  EnumFormFieldTypeColor: "color",
  /**
   * EnumFormFieldTypeDate
   */
  EnumFormFieldTypeDate: "date",
  /**
   * EnumFormFieldTypeDateTimeLocal
   */
  EnumFormFieldTypeDateTimeLocal: "datetime-local",
  /**
   * EnumFormFieldTypeEmail
   */
  EnumFormFieldTypeEmail: "email",
  /**
   * EnumFormFieldTypeFile
   */
  EnumFormFieldTypeFile: "file",
  /**
   * EnumFormFieldTypeHidden
   */
  EnumFormFieldTypeHidden: "hidden",
  /**
   * EnumFormFieldTypeImage
   */
  EnumFormFieldTypeImage: "image",
  /**
   * EnumFormFieldTypeMonth
   */
  EnumFormFieldTypeMonth: "month",
  /**
   * EnumFormFieldTypeNumber
   */
  EnumFormFieldTypeNumber: "number",
  /**
   * EnumFormFieldTypePassword
   */
  EnumFormFieldTypePassword: "password",
  /**
   * EnumFormFieldTypeRadio
   */
  EnumFormFieldTypeRadio: "radio",
  /**
   * EnumFormFieldTypeRange
   */
  EnumFormFieldTypeRange: "range",
  /**
   * EnumFormFieldTypeReset
   */
  EnumFormFieldTypeReset: "reset",
  /**
   * EnumFormFieldTypeSearch
   */
  EnumFormFieldTypeSearch: "search",
  /**
   * EnumFormFieldTypeSubmit
   */
  EnumFormFieldTypeSubmit: "submit",
  /**
   * EnumFormFieldTypeTel
   */
  EnumFormFieldTypeTel: "tel",
  /**
   * EnumFormFieldTypeText
   */
  EnumFormFieldTypeText: "text",
  /**
   * EnumFormFieldTypeTime
   */
  EnumFormFieldTypeTime: "time",
  /**
   * EnumFormFieldTypeURL
   */
  EnumFormFieldTypeUrl: "url",
  /**
   * EnumFormFieldTypeWeek
   */
  EnumFormFieldTypeWeek: "week",
  /**
   * EnumFormFieldTypeNuveiCard
   */
  EnumFormFieldTypeNuveiCard: "nuvei_card",
  /**
   * EnumFormFieldTypeDropdown
   */
  EnumFormFieldTypeDropdown: "dropdown",
} as const;

/**
 * The type of the form field.
 */
export type EnumFormFieldType =
  (typeof EnumFormFieldType)[keyof typeof EnumFormFieldType];

/**
 * Constrains this field's selectable options based on the value of another field. Used for dependent dropdowns (e.g. crypto currency options depend on the selected network). This is the source of truth shared by frontend option filtering and backend validation.
 */
export type FormFieldOptionConstraints = {
  /**
   * The id of the controlling field whose value constrains this field's options.
   */
  field: string;
  /**
   * Maps each controlling-field value to the list of option ids allowed for this field.
   */
  allowed: {
    [key: string]: Array<string>;
  };
};

/**
 * The validation descriptor of a form field.
 */
export type FormFieldValidationDescriptor = {
  /**
   * Indicates if the field is required.
   */
  required?: boolean;
  /**
   * The minimum length for a string field.
   */
  min_length?: number;
  /**
   * The maximum length for a string field.
   */
  max_length?: number;
  /**
   * The min attribute defines the minimum value that is acceptable and valid for the input containing the attribute.
   */
  min?: string;
  /**
   * The max attribute defines the maximum value that is acceptable and valid for the input containing the attribute.
   */
  max?: string;
  /**
   * A regular expression that the field value must match.
   */
  pattern?: string;
  /**
   * A message which will be displayed to the user if the pattern is not matched.
   */
  pattern_message?: string;
  /**
   * A message which will be displayed to the user if the field is empty.
   */
  pattern_error?: string;
  /**
   * The list of allowed values for the field.
   */
  one_of?: string;
};

export type InlineResponse200 = {
  source_balance?: AmountCurrencyResponse;
  target_balance?: AmountCurrencyResponse;
};

export type InlineResponse201 = InitSessionTokenResponse & {
  /**
   * Pepperstone transaction id
   */
  reference_id: string;
  /**
   * The URL of the form action.
   */
  redirect_url: string;
  action_type: EnumActionType;
  /**
   * The order ID provided by PSP Service.
   */
  order_id?: number;
  /**
   * ID of the saved payment account to be used for Deposit
   */
  saved_payment_account_id?: string;
};

export type InlineResponse2001 = {
  free_margin: AmountCurrencyResponse;
};

export type TradingAccountRefundBalancePayoutAccounts = {
  accounts?: Array<SavedPaymentAccountSummary>;
  payment_method?: CashierPaymentMethod;
};

export type CreateInternalTransfer = {
  amount_with_currency: AmountCurrencyRequest;
  /**
   * ID of the source trading account
   */
  source_id: string;
  /**
   * ID of the target trading account
   */
  target_id: string;
};

export type ConfirmInternalTransfer = {
  /**
   * reference ID of the transaction
   */
  reference_id: string;
};

/**
 * Card expiry date update request
 */
export type UpdateSavedPaymentAccountCardExpiryDateRequest = {
  /**
   * The new expiry date of the card in MM/YYYY format.
   */
  expiry_date: string;
};

/**
 * Update deposit transaction with card token or existing saved payment account
 */
export type UpdateDepositTransactionRequest = {
  /**
   * The temporary credit card token from the Nuvei getToken call. Used for new card deposits.
   */
  cc_temp_token?: string;
  /**
   * The ID of an existing saved payment account to use for this deposit. Used when the customer selects a previously saved card.
   */
  saved_payment_account_id?: string;
  form_fields?: SavedPaymentAccountFields;
  /**
   * The unique identifier of the saved payment method given by the PSP provider UPO for Credit Card or payer ID for PayPal.
   */
  psp_token?: string;
  apm_fields?: ApmDepositConfirmRequest;
};

/**
 * Create a Saved Payment account deletion request
 */
export type SavedPaymentAccountDeletionRequest = {
  /**
   * The reason for deleting the saved payment account.
   */
  reason: string;
  /**
   * The id of the document related to the deletion request.
   */
  document_id?: string;
};

export type HealthData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/__health__";
};

export type HealthResponses = {
  /**
   * Health check response
   */
  200: Result;
};

export type HealthResponse = HealthResponses[keyof HealthResponses];

export type VersionData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/cashier/__version__";
};

export type VersionErrors = {
  /**
   * Server error response, returned when the server encounters an unexpected or unhandled error
   */
  500: Error;
};

export type VersionError = VersionErrors[keyof VersionErrors];

export type VersionResponses = {
  /**
   * Last build commit hash and time as version
   */
  200: ServiceVersion;
};

export type VersionResponse = VersionResponses[keyof VersionResponses];

export type GetCashierV1AuthenticationLoginData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/cashier/v1/authentication/login";
};

export type GetCashierV1AuthenticationLoginErrors = {
  /**
   * Server error response, returned when the server encounters an unexpected or unhandled error
   */
  500: Error;
};

export type GetCashierV1AuthenticationLoginError =
  GetCashierV1AuthenticationLoginErrors[keyof GetCashierV1AuthenticationLoginErrors];

export type GetCashierV1AuthenticationOauthData = {
  body?: never;
  path?: never;
  query: {
    /**
     * OAuth2 code
     */
    code: string;
    /**
     * OAuth2 state
     */
    state: string;
  };
  url: "/cashier/v1/authentication/oauth";
};

export type GetCashierV1AuthenticationOauthErrors = {
  /**
   * Unauthorized
   */
  401: Error;
  /**
   * Server error response, returned when the server encounters an unexpected or unhandled error
   */
  500: Error;
};

export type GetCashierV1AuthenticationOauthError =
  GetCashierV1AuthenticationOauthErrors[keyof GetCashierV1AuthenticationOauthErrors];

export type GetCashierV1AuthenticationOauthResponses = {
  /**
   * OAuth2 callback response
   */
  200: Tokens;
};

export type GetCashierV1AuthenticationOauthResponse =
  GetCashierV1AuthenticationOauthResponses[keyof GetCashierV1AuthenticationOauthResponses];

export type GetCashierV1AuthenticationVerifyData = {
  body?: never;
  headers: {
    /**
     * Okta JWT token
     */
    Authorization: string;
  };
  path?: never;
  query?: never;
  url: "/cashier/v1/authentication/verify";
};

export type GetCashierV1AuthenticationVerifyErrors = {
  /**
   * Unauthorized
   */
  401: Error;
  /**
   * Server error response, returned when the server encounters an unexpected or unhandled error
   */
  500: Error;
};

export type GetCashierV1AuthenticationVerifyError =
  GetCashierV1AuthenticationVerifyErrors[keyof GetCashierV1AuthenticationVerifyErrors];

export type GetCashierV1AuthenticationVerifyResponses = {
  /**
   * Payment method verification details
   */
  200: TokenVerification;
};

export type GetCashierV1AuthenticationVerifyResponse =
  GetCashierV1AuthenticationVerifyResponses[keyof GetCashierV1AuthenticationVerifyResponses];

export type GetOrCreateCashierUserData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/cashier/v1/authentication/user-data";
};

export type GetOrCreateCashierUserErrors = {
  /**
   * Unauthorized
   */
  401: Error;
  /**
   * Server error response, returned when the server encounters an unexpected or unhandled error
   */
  500: Error;
};

export type GetOrCreateCashierUserError =
  GetOrCreateCashierUserErrors[keyof GetOrCreateCashierUserErrors];

export type GetOrCreateCashierUserResponses = {
  /**
   * Customer data retrieved successfully
   */
  200: CashierUserData;
};

export type GetOrCreateCashierUserResponse =
  GetOrCreateCashierUserResponses[keyof GetOrCreateCashierUserResponses];

export type InternalTransferCreateData = {
  body?: CreateInternalTransfer;
  path?: never;
  query?: never;
  url: "/transfer/v1/create";
};

export type InternalTransferCreateErrors = {
  /**
   * Invalid request
   */
  400: Error;
  /**
   * Server error response, returned when the server encounters an unexpected or unhandled error
   */
  500: Error;
};

export type InternalTransferCreateError =
  InternalTransferCreateErrors[keyof InternalTransferCreateErrors];

export type InternalTransferCreateResponses = {
  /**
   * Internal transfer successful
   */
  200: CreateInternalTransferResponse;
};

export type InternalTransferCreateResponse =
  InternalTransferCreateResponses[keyof InternalTransferCreateResponses];

export type InternalTransferConfirmData = {
  body?: ConfirmInternalTransfer;
  path?: never;
  query?: never;
  url: "/transfer/v1/confirm";
};

export type InternalTransferConfirmErrors = {
  /**
   * Invalid request
   */
  400: Error;
  /**
   * Conflict. Multiple concurrent requests are detected.
   */
  409: Error;
  /**
   * Insufficient funds for transfer
   */
  422: Error;
  /**
   * Server error response, returned when the server encounters an unexpected or unhandled error
   */
  500: Error;
};

export type InternalTransferConfirmError =
  InternalTransferConfirmErrors[keyof InternalTransferConfirmErrors];

export type InternalTransferConfirmResponses = {
  /**
   * Internal transfer successful
   */
  200: InlineResponse200;
};

export type InternalTransferConfirmResponse =
  InternalTransferConfirmResponses[keyof InternalTransferConfirmResponses];

export type GetInternalCodesData = {
  body?: never;
  path?: never;
  query: {
    "license-name": string;
    "country-code": string;
    "currency-code": string;
  };
  url: "/cashier/v1/internal-codes";
};

export type GetInternalCodesErrors = {
  /**
   * Server error response, returned when the server encounters an unexpected or unhandled error
   */
  500: Error;
};

export type GetInternalCodesError =
  GetInternalCodesErrors[keyof GetInternalCodesErrors];

export type GetInternalCodesResponses = {
  /**
   * Internal codes retrieved successfully
   */
  200: InternalCodes;
};

export type GetInternalCodesResponse =
  GetInternalCodesResponses[keyof GetInternalCodesResponses];

export type GetTransactionsData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/cashier/v1/transactions";
};

export type GetTransactionsErrors = {
  /**
   * Server error response, returned when the server encounters an unexpected or unhandled error
   */
  500: Error;
};

export type GetTransactionsError =
  GetTransactionsErrors[keyof GetTransactionsErrors];

export type GetTransactionsResponses = {
  /**
   * GetCashierTransactionsResponse
   */
  200: Array<CashierTransactionView>;
};

export type GetTransactionsResponse =
  GetTransactionsResponses[keyof GetTransactionsResponses];

export type GetTransactionDetailsData = {
  body?: never;
  path: {
    /**
     * Payment method direction
     */
    paymentType: EnumPaymentType;
    /**
     * The reference ID of the transaction (e.g., P123456, W123456, TR123456)
     */
    referenceID: string;
  };
  query?: never;
  url: "/cashier/v1/transactions/{paymentType}/{referenceID}";
};

export type GetTransactionDetailsErrors = {
  /**
   * Server error response, returned when the server encounters an unexpected or unhandled error
   */
  500: Error;
};

export type GetTransactionDetailsError =
  GetTransactionDetailsErrors[keyof GetTransactionDetailsErrors];

export type GetTransactionDetailsResponses = {
  /**
   * GetCashierTransactionDetailsResponse
   */
  200: CashierTransactionViewDetails;
};

export type GetTransactionDetailsResponse =
  GetTransactionDetailsResponses[keyof GetTransactionDetailsResponses];

export type GetTransactionStatusData = {
  body?: never;
  path: {
    /**
     * The reference ID of the transaction (e.g., P123456, W123456, TR123456)
     */
    referenceID: string;
  };
  query: {
    /**
     * Payment method direction
     */
    "payment-type": EnumArrangementType;
  };
  url: "/cashier/v1/transactions/{referenceID}/status";
};

export type GetTransactionStatusErrors = {
  /**
   * Not found error response, returned when the requested resource cannot be found (usually based on path or query parameters)
   */
  404: Error;
  /**
   * Server error response, returned when the server encounters an unexpected or unhandled error
   */
  500: Error;
};

export type GetTransactionStatusError =
  GetTransactionStatusErrors[keyof GetTransactionStatusErrors];

export type GetTransactionStatusResponses = {
  /**
   * Get transaction status response
   */
  200: TransactionSummary;
};

export type GetTransactionStatusResponse =
  GetTransactionStatusResponses[keyof GetTransactionStatusResponses];

export type GetExchangeRateData = {
  body?: never;
  path?: never;
  query: {
    "from-currency-code": string;
    "to-currency-code": string;
    amount: string;
    "country-code": string;
    "license-id": string;
    "payment-method-id": string;
    "is-reverse": boolean;
  };
  url: "/cashier/v1/exchange-rate";
};

export type GetExchangeRateErrors = {
  /**
   * Server error response, returned when the server encounters an unexpected or unhandled error
   */
  500: Error;
};

export type GetExchangeRateError =
  GetExchangeRateErrors[keyof GetExchangeRateErrors];

export type GetExchangeRateResponses = {
  /**
   * Exchange Rate retrieved successfully
   */
  200: ExchangeRate;
};

export type GetExchangeRateResponse =
  GetExchangeRateResponses[keyof GetExchangeRateResponses];

export type GetRawExchangeRateData = {
  body?: never;
  path?: never;
  query: {
    "from-currency-code": string;
    "to-currency-code": string;
    amount: string;
  };
  url: "/cashier/v1/raw-exchange-rate";
};

export type GetRawExchangeRateErrors = {
  /**
   * Server error response, returned when the server encounters an unexpected or unhandled error
   */
  500: Error;
};

export type GetRawExchangeRateError =
  GetRawExchangeRateErrors[keyof GetRawExchangeRateErrors];

export type GetRawExchangeRateResponses = {
  /**
   * Exchange Rate retrieved successfully
   */
  200: RawExchangeRate;
};

export type GetRawExchangeRateResponse =
  GetRawExchangeRateResponses[keyof GetRawExchangeRateResponses];

export type GetTransferExchangeRateData = {
  body?: never;
  path?: never;
  query: {
    "from-currency-code": string;
    "to-currency-code": string;
    amount: string;
    "is-reverse": boolean;
  };
  url: "/transfer/v1/exchange-rate";
};

export type GetTransferExchangeRateErrors = {
  /**
   * Server error response, returned when the server encounters an unexpected or unhandled error
   */
  500: Error;
};

export type GetTransferExchangeRateError =
  GetTransferExchangeRateErrors[keyof GetTransferExchangeRateErrors];

export type GetTransferExchangeRateResponses = {
  /**
   * Exchange Rate retrieved successfully
   */
  200: TransferExchangeRateResponse;
};

export type GetTransferExchangeRateResponse =
  GetTransferExchangeRateResponses[keyof GetTransferExchangeRateResponses];

export type GetTradingAccountsData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/transfer/v1/trading-accounts";
};

export type GetTradingAccountsErrors = {
  /**
   * Unauthorized
   */
  401: Error;
  /**
   * Server error response, returned when the server encounters an unexpected or unhandled error
   */
  500: Error;
};

export type GetTradingAccountsError =
  GetTradingAccountsErrors[keyof GetTradingAccountsErrors];

export type GetTradingAccountsResponses = {
  /**
   * Trading accounts retrieved successfully
   */
  200: TradingAccountsByMarginResponse;
};

export type GetTradingAccountsResponse =
  GetTradingAccountsResponses[keyof GetTradingAccountsResponses];

export type GetCurrenciesData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/cashier/v1/currencies";
};

export type GetCurrenciesErrors = {
  /**
   * Server error response, returned when the server encounters an unexpected or unhandled error
   */
  500: Error;
};

export type GetCurrenciesError = GetCurrenciesErrors[keyof GetCurrenciesErrors];

export type GetCurrenciesResponses = {
  /**
   * Get currencies
   */
  200: {
    [key: string]: CurrencyPrimitive;
  };
};

export type GetCurrenciesResponse =
  GetCurrenciesResponses[keyof GetCurrenciesResponses];

export type GetPageAlertData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/cashier/v1/page-alert";
};

export type GetPageAlertErrors = {
  /**
   * Server error response, returned when the server encounters an unexpected or unhandled error
   */
  500: Error;
};

export type GetPageAlertError = GetPageAlertErrors[keyof GetPageAlertErrors];

export type GetPageAlertResponses = {
  /**
   * Cashier page alert retrieved successfully
   */
  200: PageAlert;
};

export type GetPageAlertResponse =
  GetPageAlertResponses[keyof GetPageAlertResponses];

export type UpdateCardExpiryDateData = {
  /**
   * Card expiry date update request
   */
  body: UpdateSavedPaymentAccountCardExpiryDateRequest;
  path: {
    savedPaymentAccountID: string;
  };
  query?: never;
  url: "/cashier/v1/saved-payment-accounts/{savedPaymentAccountID}/card-expiry-date";
};

export type UpdateCardExpiryDateErrors = {
  /**
   * Invalid request
   */
  400: Error;
  /**
   * Not found error response, returned when the requested resource cannot be found (usually based on path or query parameters)
   */
  404: Error;
  /**
   * Server error response, returned when the server encounters an unexpected or unhandled error
   */
  500: Error;
};

export type UpdateCardExpiryDateError =
  UpdateCardExpiryDateErrors[keyof UpdateCardExpiryDateErrors];

export type UpdateCardExpiryDateResponses = {
  /**
   * Card expiry date has been updated
   */
  200: unknown;
};

export type StartTransactionData = {
  body: StartDepositTransaction;
  path?: never;
  query?: never;
  url: "/deposit/v1/start-transaction";
};

export type StartTransactionErrors = {
  /**
   * Bad Request
   */
  400: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type StartTransactionError =
  StartTransactionErrors[keyof StartTransactionErrors];

export type StartTransactionResponses = {
  /**
   * Successful response for starting a deposit transaction with the reference id of the transaction and payment flow action
   */
  201: InlineResponse201;
};

export type StartTransactionResponse =
  StartTransactionResponses[keyof StartTransactionResponses];

export type UpdateTransactionData = {
  /**
   * Update deposit transaction with card token or existing saved payment account
   */
  body: UpdateDepositTransactionRequest;
  path: {
    /**
     * The reference ID of the transaction (e.g., P123456, W123456, TR123456)
     */
    referenceID: string;
  };
  query?: never;
  url: "/deposit/v1/transactions/{referenceID}";
};

export type UpdateTransactionErrors = {
  /**
   * Invalid request
   */
  400: Error;
  /**
   * Transaction is not in pending state and cannot be updated (key deposit.transaction_not_pending)
   */
  409: Error;
  /**
   * Either the BIN code is blocked for the payment method or the country is blocked for the license
   */
  422: Error;
};

export type UpdateTransactionError =
  UpdateTransactionErrors[keyof UpdateTransactionErrors];

export type UpdateTransactionResponses = {
  /**
   * Transaction updated successfully. For new card flow, contains the UPO ID to use in createPayment.
   */
  200: UpdateDepositTransactionResponse;
};

export type UpdateTransactionResponse =
  UpdateTransactionResponses[keyof UpdateTransactionResponses];

export type CancelDepositTransactionData = {
  body?: never;
  path: {
    /**
     * The reference ID of the transaction (e.g., P123456, W123456, TR123456)
     */
    referenceID: string;
  };
  query?: never;
  url: "/deposit/v1/transactions/{referenceID}/cancellation";
};

export type CancelDepositTransactionErrors = {
  /**
   * Transaction not found
   */
  404: Error;
  /**
   * Transaction is not in a cancellable state (key deposit.transaction_not_pending)
   */
  409: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type CancelDepositTransactionError =
  CancelDepositTransactionErrors[keyof CancelDepositTransactionErrors];

export type CancelDepositTransactionResponses = {
  /**
   * Transaction cancelled successfully
   */
  204: void;
};

export type CancelDepositTransactionResponse =
  CancelDepositTransactionResponses[keyof CancelDepositTransactionResponses];

export type PaymentMethodsData = {
  body?: never;
  path?: never;
  query: {
    "external-trading-account-id": number;
    "trading-platform": EnumTradingPlatform;
  };
  url: "/deposit/v1/payment-methods";
};

export type PaymentMethodsErrors = {
  /**
   * Bad Request
   */
  400: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type PaymentMethodsError =
  PaymentMethodsErrors[keyof PaymentMethodsErrors];

export type PaymentMethodsResponses = {
  /**
   * Payment methods retrieved successfully
   */
  200: GetPaymentMethodsResponse;
};

export type PaymentMethodsResponse =
  PaymentMethodsResponses[keyof PaymentMethodsResponses];

export type WithdrawalPaymentMethodsData = {
  body?: never;
  path: {
    tradingAccountID: string;
  };
  query?: never;
  url: "/withdrawal/v1/payment-methods/{tradingAccountID}";
};

export type WithdrawalPaymentMethodsErrors = {
  /**
   * Bad Request
   */
  400: Error;
  /**
   * Withdrawals are not permitted for this trading account (e.g. a demo account)
   */
  403: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type WithdrawalPaymentMethodsError =
  WithdrawalPaymentMethodsErrors[keyof WithdrawalPaymentMethodsErrors];

export type WithdrawalPaymentMethodsResponses = {
  /**
   * Payment methods retrieved successfully
   */
  200: GetWithdrawalPaymentMethodsResponse;
};

export type WithdrawalPaymentMethodsResponse =
  WithdrawalPaymentMethodsResponses[keyof WithdrawalPaymentMethodsResponses];

export type GetPaymentMethodGroupByIdData = {
  body?: never;
  path: {
    paymentMethodGroupID: string;
  };
  query?: never;
  url: "/deposit/v1/payment-method-groups/{paymentMethodGroupID}";
};

export type GetPaymentMethodGroupByIdErrors = {
  /**
   * Payment method not found
   */
  404: Error;
};

export type GetPaymentMethodGroupByIdError =
  GetPaymentMethodGroupByIdErrors[keyof GetPaymentMethodGroupByIdErrors];

export type GetPaymentMethodGroupByIdResponses = {
  /**
   * Payment method details
   */
  200: PaymentMethodGroupWithMembers;
};

export type GetPaymentMethodGroupByIdResponse =
  GetPaymentMethodGroupByIdResponses[keyof GetPaymentMethodGroupByIdResponses];

export type CreateSavedPaymentAccountDeletionRequestByIdData = {
  /**
   * Create a Saved Payment account deletion request
   */
  body: SavedPaymentAccountDeletionRequest;
  path: {
    savedPaymentAccountID: string;
  };
  query?: never;
  url: "/deposit/v1/saved-payment-accounts/{savedPaymentAccountID}/deletion-request";
};

export type CreateSavedPaymentAccountDeletionRequestByIdErrors = {
  /**
   * Saved Payment Account not found
   */
  404: Error;
};

export type CreateSavedPaymentAccountDeletionRequestByIdError =
  CreateSavedPaymentAccountDeletionRequestByIdErrors[keyof CreateSavedPaymentAccountDeletionRequestByIdErrors];

export type CreateSavedPaymentAccountDeletionRequestByIdResponses = {
  /**
   * Saved Payment Account deletion request successful
   */
  200: Result;
};

export type CreateSavedPaymentAccountDeletionRequestByIdResponse =
  CreateSavedPaymentAccountDeletionRequestByIdResponses[keyof CreateSavedPaymentAccountDeletionRequestByIdResponses];

export type GetWithdrawalRequestAmountData = {
  body?: never;
  path: {
    withdrawalRequestID: string;
  };
  query?: never;
  url: "/withdrawal/v1/requests/{withdrawalRequestID}/amount";
};

export type GetWithdrawalRequestAmountErrors = {
  /**
   * Bad Request
   */
  400: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type GetWithdrawalRequestAmountError =
  GetWithdrawalRequestAmountErrors[keyof GetWithdrawalRequestAmountErrors];

export type GetWithdrawalRequestAmountResponses = {
  /**
   * Total amount of a withdrawal transactions
   */
  200: WithdrawalRequestTotalAmount;
};

export type GetWithdrawalRequestAmountResponse =
  GetWithdrawalRequestAmountResponses[keyof GetWithdrawalRequestAmountResponses];

export type GetTradingAccountRefundBalanceData = {
  body?: never;
  path: {
    tradingAccountID: string;
  };
  query?: never;
  url: "/withdrawal/v1/trading-accounts/{tradingAccountID}/refund";
};

export type GetTradingAccountRefundBalanceErrors = {
  /**
   * Invalid request
   */
  400: Error;
  /**
   * Withdrawals are not permitted for this trading account (e.g. a demo account)
   */
  403: Error;
};

export type GetTradingAccountRefundBalanceError =
  GetTradingAccountRefundBalanceErrors[keyof GetTradingAccountRefundBalanceErrors];

export type GetTradingAccountRefundBalanceResponses = {
  /**
   * Gets the refundable balance for a specific trading account
   */
  200: TradingAccountRefundBalance;
};

export type GetTradingAccountRefundBalanceResponse =
  GetTradingAccountRefundBalanceResponses[keyof GetTradingAccountRefundBalanceResponses];

export type InitSessionTokenData = {
  body?: never;
  path: {
    tradingAccountID: string;
    paymentMethodID: string;
  };
  query?: never;
  url: "/cashier/v1/trading-accounts/{tradingAccountID}/payment-methods/{paymentMethodID}/session";
};

export type InitSessionTokenErrors = {
  /**
   * Invalid request
   */
  400: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type InitSessionTokenError =
  InitSessionTokenErrors[keyof InitSessionTokenErrors];

export type InitSessionTokenResponses = {
  /**
   * Successful response for getting a session token for WEB SDK
   */
  200: InitSessionTokenResponse;
};

export type InitSessionTokenResponse2 =
  InitSessionTokenResponses[keyof InitSessionTokenResponses];

export type CreateSavedPaymentAccountData = {
  /**
   * Create a new saved payment account schema.
   */
  body: CreateSavedPaymentAccountSchema;
  path: {
    tradingAccountID: string;
    paymentMethodID: string;
  };
  query?: never;
  url: "/withdrawal/v1/trading-accounts/{tradingAccountID}/payment-methods/{paymentMethodID}/saved-payment-accounts/create";
};

export type CreateSavedPaymentAccountErrors = {
  /**
   * Invalid request
   */
  400: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type CreateSavedPaymentAccountError =
  CreateSavedPaymentAccountErrors[keyof CreateSavedPaymentAccountErrors];

export type CreateSavedPaymentAccountResponses = {
  /**
   * Created saved payment account for the customer
   */
  200: SavedPaymentAccountSummary;
};

export type CreateSavedPaymentAccountResponse =
  CreateSavedPaymentAccountResponses[keyof CreateSavedPaymentAccountResponses];

export type GetSavedPaymentAccountsProfitData = {
  body?: never;
  path: {
    tradingAccountID: string;
  };
  query?: never;
  url: "/withdrawal/v1/trading-accounts/{tradingAccountID}/saved-payment-accounts/profit";
};

export type GetSavedPaymentAccountsProfitErrors = {
  /**
   * Invalid request
   */
  400: Error;
  /**
   * Withdrawals are not permitted for this trading account (e.g. a demo account)
   */
  403: Error;
};

export type GetSavedPaymentAccountsProfitError =
  GetSavedPaymentAccountsProfitErrors[keyof GetSavedPaymentAccountsProfitErrors];

export type GetSavedPaymentAccountsProfitResponses = {
  /**
   * Gets all saved payment accounts for the customer
   */
  200: Array<SavedPaymentAccountSummary>;
};

export type GetSavedPaymentAccountsProfitResponse =
  GetSavedPaymentAccountsProfitResponses[keyof GetSavedPaymentAccountsProfitResponses];

export type UpdateDocumentStatusByIdData = {
  body: DocumentUpdateStatusRequest;
  path: {
    documentID: string;
  };
  query?: never;
  url: "/cashier/v1/documents/{documentID}/status";
};

export type UpdateDocumentStatusByIdErrors = {
  /**
   * Document not found
   */
  404: Error;
};

export type UpdateDocumentStatusByIdError =
  UpdateDocumentStatusByIdErrors[keyof UpdateDocumentStatusByIdErrors];

export type UpdateDocumentStatusByIdResponses = {
  /**
   * Document update result
   */
  200: Result;
};

export type UpdateDocumentStatusByIdResponse =
  UpdateDocumentStatusByIdResponses[keyof UpdateDocumentStatusByIdResponses];

export type SaveWithdrawalRequestData = {
  body: WithdrawalRequest;
  path: {
    tradingAccountID: string;
  };
  query?: never;
  url: "/withdrawal/v1/trading-accounts/{tradingAccountID}/request";
};

export type SaveWithdrawalRequestErrors = {
  /**
   * Invalid request
   */
  400: Error;
  /**
   * Withdrawals are not permitted for this trading account (e.g. a demo account)
   */
  403: Error;
  /**
   * Trading account not found
   */
  404: Error;
  /**
   * The withdrawal request cannot be processed due to insufficient funds.
   */
  422: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type SaveWithdrawalRequestError =
  SaveWithdrawalRequestErrors[keyof SaveWithdrawalRequestErrors];

export type SaveWithdrawalRequestResponses = {
  /**
   * Withdrawal request created successfully and the calculated amount is returned
   */
  200: WithdrawalRequestCreated;
};

export type SaveWithdrawalRequestResponse =
  SaveWithdrawalRequestResponses[keyof SaveWithdrawalRequestResponses];

export type OtpVerifyWithdrawalRequestData = {
  /**
   * The request body for verifying a withdrawal request.
   */
  body: WithdrawalMfaVerification;
  path: {
    withdrawalRequestID: string;
  };
  query?: never;
  url: "/withdrawal/v1/requests/{withdrawalRequestID}/otp-verify";
};

export type OtpVerifyWithdrawalRequestErrors = {
  /**
   * Invalid request
   */
  400: Error;
  /**
   * Withdrawal request not verified
   */
  403: Error;
  /**
   * Trading account not found
   */
  404: Error;
  /**
   * The withdrawal request cannot be processed due to insufficient funds.
   */
  422: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type OtpVerifyWithdrawalRequestError =
  OtpVerifyWithdrawalRequestErrors[keyof OtpVerifyWithdrawalRequestErrors];

export type OtpVerifyWithdrawalRequestResponses = {
  /**
   * Successful withdrawal request verification
   */
  200: WithdrawalVerificationResult;
};

export type OtpVerifyWithdrawalRequestResponse =
  OtpVerifyWithdrawalRequestResponses[keyof OtpVerifyWithdrawalRequestResponses];

export type EmailVerifyWithdrawalRequestData = {
  body?: never;
  path: {
    withdrawalRequestID: string;
  };
  query: {
    emailVerificationToken: string;
  };
  url: "/withdrawal/v1/requests/{withdrawalRequestID}/email-verify";
};

export type EmailVerifyWithdrawalRequestErrors = {
  /**
   * Invalid request
   */
  400: Error;
  /**
   * Withdrawal request not verified
   */
  403: Error;
  /**
   * Trading account not found
   */
  404: Error;
  /**
   * The withdrawal request cannot be processed due to insufficient funds.
   */
  422: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type EmailVerifyWithdrawalRequestError =
  EmailVerifyWithdrawalRequestErrors[keyof EmailVerifyWithdrawalRequestErrors];

export type EmailVerifyWithdrawalRequestResponses = {
  /**
   * Successful withdrawal request verification
   */
  200: WithdrawalVerificationResult;
};

export type EmailVerifyWithdrawalRequestResponse =
  EmailVerifyWithdrawalRequestResponses[keyof EmailVerifyWithdrawalRequestResponses];

export type CancelWithdrawalRequestData = {
  body?: never;
  path: {
    withdrawalRequestID: string;
  };
  query?: never;
  url: "/withdrawal/v1/requests/{withdrawalRequestID}/cancel";
};

export type CancelWithdrawalRequestErrors = {
  /**
   * Invalid request
   */
  400: Error;
  /**
   * Withdrawal request not verified
   */
  403: Error;
  /**
   * Trading account not found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type CancelWithdrawalRequestError =
  CancelWithdrawalRequestErrors[keyof CancelWithdrawalRequestErrors];

export type CancelWithdrawalRequestResponses = {
  /**
   * Successful withdrawal request cancellation
   */
  200: WithdrawalVerificationResult;
};

export type CancelWithdrawalRequestResponse =
  CancelWithdrawalRequestResponses[keyof CancelWithdrawalRequestResponses];

export type GetWithdrawalRequestStatusData = {
  body?: never;
  path: {
    withdrawalRequestID: string;
  };
  query?: never;
  url: "/withdrawal/v1/requests/{withdrawalRequestID}/status";
};

export type GetWithdrawalRequestStatusErrors = {
  /**
   * Invalid request
   */
  400: Error;
  /**
   * Trading account or withdrawal request not found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type GetWithdrawalRequestStatusError =
  GetWithdrawalRequestStatusErrors[keyof GetWithdrawalRequestStatusErrors];

export type GetWithdrawalRequestStatusResponses = {
  /**
   * Current withdrawal request status
   */
  200: WithdrawalRequestStatus;
};

export type GetWithdrawalRequestStatusResponse =
  GetWithdrawalRequestStatusResponses[keyof GetWithdrawalRequestStatusResponses];

export type ResendEmailVerificationWithdrawalRequestData = {
  body?: never;
  path: {
    withdrawalRequestID: string;
  };
  query?: never;
  url: "/withdrawal/v1/requests/{withdrawalRequestID}/resend-email";
};

export type ResendEmailVerificationWithdrawalRequestErrors = {
  /**
   * Invalid request
   */
  400: Error;
  /**
   * Trading account or withdrawal request not found
   */
  404: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type ResendEmailVerificationWithdrawalRequestError =
  ResendEmailVerificationWithdrawalRequestErrors[keyof ResendEmailVerificationWithdrawalRequestErrors];

export type ResendEmailVerificationWithdrawalRequestResponses = {
  /**
   * Successful resend of the withdrawal request verification email, no content returned
   */
  204: void;
};

export type ResendEmailVerificationWithdrawalRequestResponse =
  ResendEmailVerificationWithdrawalRequestResponses[keyof ResendEmailVerificationWithdrawalRequestResponses];

export type CalculateSavedPaymentAccountTransactionsData = {
  body: WithdrawalRequest;
  path: {
    tradingAccountID: string;
  };
  query?: never;
  url: "/withdrawal/v1/trading-accounts/{tradingAccountID}/saved-payment-accounts/calculate-transactions";
};

export type CalculateSavedPaymentAccountTransactionsErrors = {
  /**
   * Invalid request
   */
  400: Error;
  /**
   * The withdrawal request cannot be processed due to insufficient funds.
   */
  422: Error;
};

export type CalculateSavedPaymentAccountTransactionsError =
  CalculateSavedPaymentAccountTransactionsErrors[keyof CalculateSavedPaymentAccountTransactionsErrors];

export type CalculateSavedPaymentAccountTransactionsResponses = {
  /**
   * Post all saved payment accounts with amounts
   */
  200: CalculatedTransactions;
};

export type CalculateSavedPaymentAccountTransactionsResponse =
  CalculateSavedPaymentAccountTransactionsResponses[keyof CalculateSavedPaymentAccountTransactionsResponses];

export type GetDocumentByIdData = {
  body?: never;
  path: {
    documentID: string;
  };
  query?: never;
  url: "/cashier/v1/documents/{documentID}";
};

export type GetDocumentByIdErrors = {
  /**
   * Document not found
   */
  404: Error;
};

export type GetDocumentByIdError =
  GetDocumentByIdErrors[keyof GetDocumentByIdErrors];

export type GetDocumentByIdResponses = {
  /**
   * Document item
   */
  200: CustomerDocumentResponse;
};

export type GetDocumentByIdResponse =
  GetDocumentByIdResponses[keyof GetDocumentByIdResponses];

export type CreateDocumentData = {
  body: DocumentCreationRequest;
  path?: never;
  query?: {
    /**
     * The ID of the Saved Payment Account. Optional — if omitted, document is created without a SPA link.
     */
    "saved-payment-account-id"?: string;
  };
  url: "/cashier/v1/documents";
};

export type CreateDocumentErrors = {
  /**
   * Bad Request
   */
  400: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type CreateDocumentError =
  CreateDocumentErrors[keyof CreateDocumentErrors];

export type CreateDocumentResponses = {
  /**
   * New document creation successful
   */
  200: DocumentCreationResponse;
};

export type CreateDocumentResponse =
  CreateDocumentResponses[keyof CreateDocumentResponses];

export type GetFreeMarginData = {
  body?: never;
  path: {
    tradingAccountID: string;
  };
  query?: never;
  url: "/cashier/v1/trading-accounts/{tradingAccountID}/free-margin";
};

export type GetFreeMarginErrors = {
  /**
   * Bad Request
   */
  400: Error;
  /**
   * Internal Server Error
   */
  500: Error;
};

export type GetFreeMarginError = GetFreeMarginErrors[keyof GetFreeMarginErrors];

export type GetFreeMarginResponses = {
  /**
   * Get free margin response
   */
  200: InlineResponse2001;
};

export type GetFreeMarginResponse =
  GetFreeMarginResponses[keyof GetFreeMarginResponses];
